// Translations for all static text in the application
export const translations = {
    // Menu items
    menuItems: {
        orderBoard: {
            am: "Board",
            ru: "Board",
            en: "Board"
        },
        orders: {
            am: "Պատվերներ",
            ru: "Заказы",
            en: "Orders"
        },
        chat: {
            am: "Չատ",
            ru: "Чат",
            en: "Chat"
        },
        promocodes: {
            am: "Պրոմոկոդեր",
            ru: "Промокоды",
            en: "Promocodes"
        },
        menu: {
            am: "Մենյու",
            ru: "Меню",
            en: "Menu"
        },
        schedule: {
            am: "Գրաֆիկ",
            ru: "Расписание",
            en: "Schedule"
        },
        profile: {
            am: "Պրոֆիլ",
            ru: "Профиль",
            en: "Profile"
        },
        active: {
            am: "Ակտիվ",
            ru: "Активный",
            en: "Active"
        },
        inactive: {
            am: "Ապաակտիվացված",
            ru: "Неактивный",
            en: "Inactive"
        },
        toggleStatusExplanation: {
            am: "Կարգավորեք ձեր տեսանելիությունը հարթակում",
            ru: "Настройте свою видимость на платформе",
            en: "Configure your visibility on the platform",
        },
        payments: {
            am: "Վճարներ",
            ru: "Платежи",
            en: "Payments"
        },
        clients: {
            am: "Հաճախորդներ",
            ru: "Клиенты",
            en: "Clients"
        },
        delivery: {
            am: "Առաքում",
            ru: "Доставка",
            en: "Delivery"
        },
        configurations: {
            am: "Կարգավորումներ",
            ru: "Настройки",
            en: "Configurations"
        },
        telegramPayments: {
            am: "Telegram Վճարներ",
            ru: "Telegram Платежи",
            en: "Telegram Payments"
        },
        dashboard: {
            am: "Dashboard",
            ru: "Dashboard",
            en: "Dashboard"
        },
        integrations: {
            am: "Ինտեգրումներ",
            ru: "Интеграции",
            en: "Integrations"
        }
    },
    dashboard: {
        mockBadge: {
            am: "NOT REAL DATA",
            ru: "NOT REAL DATA",
            en: "NOT REAL DATA"
        },
        periodPickerAria: {
            am: "Ժամանակային միջակայք",
            ru: "Период",
            en: "Time range"
        },
        periods: {
            today: {
                am: "Այսօր",
                ru: "Сегодня",
                en: "Today"
            },
            d7: {
                am: "7 օր",
                ru: "7 дн.",
                en: "7D"
            },
            d30: {
                am: "30 օր",
                ru: "30 дн.",
                en: "30D"
            },
            all: {
                am: "Ամբողջը",
                ru: "Всё время",
                en: "All"
            }
        },
        charts: {
            revenueTitle: {
                am: "Եկամուտ",
                ru: "Выручка",
                en: "Revenue"
            },
            topDishesTitle: {
                am: "Թոփ ուտեստներ",
                ru: "Топ блюд",
                en: "Top dishes"
            },
            ordersPerDayTitle: {
                am: "Պատվերներ օրական",
                ru: "Заказы по дням",
                en: "Orders per day"
            },
            topUsersTitle: {
                am: "Թոփ հաճախորդներ",
                ru: "Топ клиентов",
                en: "Top customers"
            },
            ordersByWeekdayTitle: {
                am: "Պատվերներ շաբաթվա օրերով",
                ru: "Заказы по дням недели",
                en: "Orders by weekday"
            },
            ordersByTimeWindowTitle: {
                am: "Պատվերներ ըստ ժամանակահատվածի",
                ru: "Заказы по времени суток",
                en: "Orders by time of day"
            },
            newVsReturningTitle: {
                am: "Նոր և վերադարձող հաճախորդներ",
                ru: "Новые и постоянные клиенты",
                en: "New vs returning customers"
            }
        },
        weekdayPeriods: {
            week: {
                am: "Շաբաթ",
                ru: "Неделя",
                en: "Week"
            },
            month: {
                am: "Ամիս",
                ru: "Месяц",
                en: "Month"
            },
            threeMonth: {
                am: "3 ամիս",
                ru: "3 мес.",
                en: "3 mo"
            },
            year: {
                am: "Տարի",
                ru: "Год",
                en: "1 yr"
            },
            all: {
                am: "Ամբողջը",
                ru: "Всё время",
                en: "All"
            }
        },
        weekdayShort: {
            mon: { am: "Երկ", ru: "Пн", en: "Mon" },
            tue: { am: "Երք", ru: "Вт", en: "Tue" },
            wed: { am: "Չրք", ru: "Ср", en: "Wed" },
            thu: { am: "Հնգ", ru: "Чт", en: "Thu" },
            fri: { am: "Ուր", ru: "Пт", en: "Fri" },
            sat: { am: "Շբթ", ru: "Сб", en: "Sat" },
            sun: { am: "Կիր", ru: "Вс", en: "Sun" }
        },
        timeWindows: {
            morning: {
                am: "10:00-11:00",
                ru: "10:00-11:00",
                en: "10:00-11:00"
            },
            lunch: {
                am: "11:00-12:00",
                ru: "11:00-12:00",
                en: "11:00-12:00"
            },
            afternoon: {
                am: "12:00-13:00",
                ru: "12:00-13:00",
                en: "12:00-13:00"
            }
        },
        customerSegments: {
            new: {
                am: "Նոր հաճախորդներ",
                ru: "Новые клиенты",
                en: "New customers"
            },
            returning: {
                am: "Վերադարձող հաճախորդներ",
                ru: "Постоянные клиенты",
                en: "Returning customers"
            }
        },
        kpi: {
            totalRevenue: {
                am: "Ընդամենը եկամուտ",
                ru: "Выручка всего",
                en: "Total revenue"
            },
            orders: {
                am: "Պատվերներ",
                ru: "Заказы",
                en: "Orders"
            }
        },
        tooltip: {
            revenue: {
                am: "Եկամուտ",
                ru: "Выручка",
                en: "Revenue"
            },
            orders: {
                am: "Պատվերներ",
                ru: "Заказы",
                en: "Orders"
            },
            customers: {
                am: "Հաճախորդներ",
                ru: "Клиенты",
                en: "Customers"
            }
        }
    },
    paymentStatuses: {
        not_payed: {
            am: "Չվճարված",
            ru: "Не оплачено",
            en: "Not paid"
        },
        pending: {
            am: "Սառեցված",
            ru: "Ожидает оплаты",
            en: "Pending"
        },
        refunded: {
            am: "Վերադարձված",
            ru: "Возвращен",
            en: "Refunded"
        },
        cancelled: {
            am: "Չեղարկված",
            ru: "Отменен",
            en: "Cancelled"
        },
        payed: {
            am: "Վճարված",
            ru: "Оплачено",
            en: "Paid"
        },
        failed: {
            am: "Ձախողված",
            ru: "Ошибка",
            en: "Failed"
        }
    },

    telegramPayments: {
        summary: {
            am: "Telegram Վճարների Ամփոփում",
            ru: "Сводка платежей Telegram",
            en: "Telegram Payments Summary"
        },
        deliveredOrders: {
            am: "Առաքված պատվերներ",
            ru: "Доставленные заказы",
            en: "Delivered Orders"
        },
        totalEarnings: {
            am: "Ընդհանուր եկամուտ",
            ru: "Общий доход",
            en: "Total Earnings"
        },
        paidOrders: {
            am: "Վճարված պատվերներ",
            ru: "Оплаченные заказы",
            en: "Paid Orders"
        },
        unpaidOrders: {
            am: "Չվճարված պատվերներ",
            ru: "Неоплаченные заказы",
            en: "Unpaid Orders"
        },
        company: {
            am: "Ընկերություն",
            ru: "Компания",
            en: "Company"
        },
        customer: {
            am: "Հաճախորդ",
            ru: "Клиент",
            en: "Customer"
        },
        price: {
            am: "Գին",
            ru: "Цена",
            en: "Price"
        }
    },

    // Order statuses
    orderStatuses: {
        all: {
            am: "Բոլորը",
            ru: "Все",
            en: "All"
        },
        requested: {
            am: "Պատվիրված",
            ru: "Запрошено",
            en: "Requested"
        },
        preparing: {
            am: "Պատրաստվում է",
            ru: "Готовится",
            en: "Preparing"
        },
        ready_for_delivery: {
            am: "Պատրաստ է",
            ru: "Готово к доставке",
            en: "Ready for Delivery"
        },
        delivery_in_progress: {
            am: "Առաքման մեջ",
            ru: "Доставка в процессе",
            en: "Delivery in Progress"
        },
        declined: {
            am: "Մերժված",
            ru: "Отклонено",
            en: "Declined"
        },
        delivered: {
            am: "Առաքված",
            ru: "Доставлено",
            en: "Delivered"
        }
    },
    toast: {
        statusUpdated: {
            am: "Կարգավիճակը հաջողությամբ փոխվեց",
            ru: "Статус успешно обновлен",
            en: "Status updated successfully",
        },
        updateFailed: {
            am: "Կարգավիճակը չի փոխվել",
            ru: "Статус не обновлен",
            en: "Status not updated",
        },
        fetchFailed: {
            am: "Չհաջողվեց ստանալ պատվերները",
            ru: "Не удалось получить заказы",
            en: "Failed to fetch orders"
        },
        translationSuccess: {
            am: "Թարգմանությունը հաջողությամբ ավարտվեց",
            ru: "Перевод выполнен успешно",
            en: "Translation completed successfully"
        },
        translationFailed: {
            am: "Թարգմանությունը ձախողվեց: Խնդրում ենք փորձել կրկին:",
            ru: "Перевод не удался. Пожалуйста, попробуйте снова.",
            en: "Failed to translate. Please try again."
        },
        enterArmenianFirst: {
            am: "Խնդրում ենք նախ մուտքագրել հայերեն անունը",
            ru: "Пожалуйста, сначала введите армянское название",
            en: "Please enter Armenian name first"
        }
    },
    common: {
        noOptions: {
            am: "Տարբերակներ չկան",
            ru: "Нет вариантов",
            en: "No options"
        },
        cancel: {
            am: "Չեղարկել",
            ru: "Отмена",
            en: "Cancel"
        },
        today: {
            am: "Այսօր",
            ru: "Сегодня",
            en: "Today"
        },
        yesterday: {
            am: "Երեկ",
            ru: "Вчера",
            en: "Yesterday"
        },
        thisWeek: {
            am: "Այս շաբաթ",
            ru: "Эта неделя",
            en: "This week"
        },
        create: {
            am: "Ստեղծել",
            ru: "Создать",
            en: "Create"
        },
        update: {
            am: "Թարմացնել",
            ru: "Обновить",
            en: "Update"
        },
        edit: {
            am: "Խմբագրել",
            ru: "Редактировать",
            en: "Edit"
        },
        delete: {
            am: "Ջնջել",
            ru: "Удалить",
            en: "Delete"
        },
        confirm: {
            am: "Հաստատել",
            ru: "Подтвердить",
            en: "Confirm"
        },
        confirmDelete: {
            am: "Վստա՞հ եք, որ ցանկանում եք ջնջել:",
            ru: "Вы уверены, что хотите удалить?",
            en: "Are you sure you want to delete?"
        },
        translating: {
            am: "Թարգմանվում է...",
            ru: "Переводится...",
            en: "Translating..."
        },
        saving: {
            am: "Պահպանվում է...",
            ru: "Сохранение...",
            en: "Saving..."
        },
        spiceLevel: {
            am: "Կծվության մակարդակ",
            ru: "Уровень остроты",
            en: "Spice Level"
        },
        comingSoon: {
            am: "Հասանելի կլինի շուտով",
            ru: "Скоро будет доступно",
            en: "Coming soon"
        },
        processing: {
            am: "Մշակվում է",
            ru: "Обработка",
            en: "Processing"
        },
        dish: {
            am: "Ուտեստ",
            ru: "Блюдо",
            en: "Dish"
        },
        productThumbnail: {
            am: "Ուտեստի նկար",
            ru: "Изображение блюда",
            en: "Product Thumbnail"
        },
        copy: {
            am: "Պատճենել",
            ru: "Копировать",
            en: "Copy"
        },
        error: {
            am: "Տեղի է ունեցել սխալ, խնդրում ենք փորձել մի փոքր ուշ",
            ru: "Произошла ошибка, пожалуйста, попробуйте позже",
            en: "An error occurred, please try again later"
        },
        success: {
            am: "Հաջողությամբ կատարված է",
            ru: "Успешно выполнено",
            en: "Successfully completed"
        },
        logout: {
            am: "Դուրս գալ",
            ru: "Выйти",
            en: "Logout"
        },
        retry: {
            am: "Կրկին փորձել",
            ru: "Повторить попытку",
            en: "Retry"
        },
        tryAgain: {
            am: "Կրկին փորձել",
            ru: "Повторить попытку",
            en: "Try again"
        },
        areYouSure: {
            am: "Համոզված ե՞ք",
            ru: "Вы уверены?",
            en: "Are you sure?"
        },
        total: {
            am: "Ընդհանուր",
            ru: "Всего",
            en: "Total"
        },
        filtered: {
            am: "Ֆիլտրված",
            ru: "Отфильтровано",
            en: "Filtered"
        },
        of: {
            am: "ից",
            ru: "из",
            en: "of"
        },
        thisMonth: {
            am: "Այս ամիս",
            ru: "Этот месяц",
            en: "This Month"
        },
        previousMonth: {
            am: "Նախորդ ամիս",
            ru: "Предыдущий месяц",
            en: "Previous Month"
        },
        pageNotFound: {
            am: "404 - Էջը չի գտնվել",
            ru: "404 - Страница не найдена",
            en: "404 - Page Not Found"
        },
        loading: {
            am: "Բեռնվում է...",
            ru: "Загрузка...",
            en: "Loading..."
        },
        calendar: {
            am: "օրացույց",
            ru: "календарь",
            en: "calendar"
        },
        search: {
            am: "Փնտրել",
            ru: "Поиск",
            en: "Search"
        },
        add: {
            am: "Ավելացնել",
            ru: "Добавить",
            en: "Add"
        },
        save: {
            am: "Պահպանել",
            ru: "Сохранить",
            en: "Save"
        },
        view: {
            am: "Դիտել",
            ru: "Посмотреть",
            en: "View"
        },
        actions: {
            am: "Գործողություններ",
            ru: "Действия",
            en: "Actions"
        },
        active: {
            am: "Ակտիվ",
            ru: "Активен",
            en: "Active"
        },
        inactive: {
            am: "Ապաակտիվ",
            ru: "Неактивен",
            en: "Inactive"
        },
        filters: {
            am: "Ֆիլտրեր",
            ru: "Фильтры",
            en: "Filters"
        },
        noDataFound: {
            am: "Տվյալներ չեն գտնվել",
            ru: "Данные не найдены",
            en: "No data found"
        },
        date: {
            am: "Ամսաթիվ",
            ru: "Дата",
            en: "Date"
        },
        available: {
            am: "Հասանելի է",
            ru: "Доступно",
            en: "Available"
        },
        action: {
            am: "Գործողություն",
            ru: "Действие",
            en: "Action"
        },
        yes: {
            am: "Այո",
            ru: "Да",
            en: "Yes"
        },
        no: {
            am: "Ոչ",
            ru: "Нет",
            en: "No"
        },
        day: {
            am: "օր",
            ru: "день",
            en: "day"
        },
        days: {
            am: "օր",
            ru: "дней",
            en: "days"
        },
        copyToClipboard: {
            am: "Պատճենել",
            ru: "Копировать",
            en: "Copy to clipboard"
        },
        copied: {
            am: "Պատճենված!",
            ru: "Скопировано!",
            en: "Copied!"
        },
        clear: {
            am: "Մաքրել",
            ru: "Очистить",
            en: "Clear"
        },
        remove: {
            am: "Հեռացնել",
            ru: "Удалить",
            en: "Remove"
        },
        done: {
            am: "Պատրաստ",
            ru: "Готово",
            en: "Done"
        },
        refreshing: {
            am: "Թարմացում",
            ru: "Загрузка",
            en: "Refreshing"
        },
        scrollToTop: {
            am: "Վերադառնալ վերև",
            ru: "Прокрутить наверх",
            en: "Scroll to top"
        },
        from: {
            am: "Սկսած",
            ru: "С",
            en: "From"
        },
        to: {
            am: "Մինչև",
            ru: "До",
            en: "To"
        },
        noMoreData: {
            am: "Այլ տվյալներ չկան",
            ru: "Больше данных нет",
            en: "No more data"
        },
        currentSelection: {
            am: "Ընթացիկ ընտրություն",
            ru: "Текущий выбор",
            en: "Current selection"
        },
        lastMonth: {
            am: "Անցած ամիս",
            ru: "Прошлый месяц",
            en: "Last month"
        },
        last7Days: {
            am: "Վերջին 7 օր",
            ru: "Последние 7 дней",
            en: "Last 7 days"
        },
        quickSelect: {
            am: "Արագ ընտրություն",
            ru: "Быстрый выбор",
            en: "Quick select"
        },
        currency: {
            am: "֏",
            ru: "֏",
            en: "AMD"
        },
        rowsPerPage: {
            am: "Տողեր էջում",
            ru: "Строк на странице",
            en: "Rows per page"
        },
        back: {
            am: "Վերադառնալ",
            ru: "Назад",
            en: "Back"
        },
        darkMode: {
            am: "Մուգ ռեժիմ",
            ru: "Темный режим",
            en: "Dark Mode"
        },
        lightMode: {
            am: "Բաց ռեժիմ",
            ru: "Светлый режим",
            en: "Light Mode"
        }
    },
    // Chat page specific translations
    chat: {
        searchPlaceholder: {
            am: "Փնտրել Չատեր...",
            ru: "Поиск чатов...",
            en: "Search chats..."
        },
        typeMessage: {
            am: "Գրեք հաղորդագրություն...",
            ru: "Напишите сообщение...",
            en: "Type a message..."
        },
        noMessages: {
            am: "Հաղորդագրություններ չկան",
            ru: "Нет сообщений",
            en: "No messages yet"
        },
        selectConversation: {
            am: "Ընտրեք չատ՝ հաղորդագրություն գրելու համար",
            ru: "Выберите чат, чтобы начать общение",
            en: "Select a chat to start messaging"
        },
        photo: {
            am: "Լուսանկար",
            ru: "Фотография",
            en: "Photo"
        },
        broadcastMenu: {
            am: "Ուղարկել այսօրվա մենյուն բոլորին",
            ru: "Отправить меню дня всем",
            en: "Send today's menu to everyone"
        },
        broadcastSuccess: {
            am: "Մենյուն հաջողությամբ ուղարկվեց",
            ru: "Меню успешно отправлено",
            en: "Menu broadcasted successfully"
        },
        selectConversationSubtitle: {
            am: "Ձեր հաճախորդները սպասում են ձեր նորություններին:",
            ru: "Ваши клиенты ждут ваших новостей!",
            en: "Your customers are waiting for your updates!"
        },
        activeOrders: {
            am: "Ակտիվ պատվերներ",
            ru: "Активные заказы",
            en: "Active Orders"
        }
    },
    errors: {
        unauthorized: {
            am: "Ձեր սեսիան լրացել է: Խնդրում ենք մուտք գործել կրկին:",
            ru: "Ваша сессия истекла. Пожалуйста, войдите снова.",
            en: "Your session has expired. Please log in again."
        },
        authError: {
            am: "Տեղի է ունեցել վավերացման սխալ:",
            ru: "Произошла ошибка аутентификации.",
            en: "An authentication error occurred."
        },
        authErrorTitle: {
            am: "Վավերացման սխալ",
            ru: "Ошибка аутентификации",
            en: "Authentication Error"
        }
    },
    // Order page
    orderBoardPage: {
        title: {
            am: "Պատվերների տախտակ",
            ru: "Доска заказов",
            en: "Order board"
        },
        deliveredHint: {
            am: "«Առաքված» սյունակը մաքրվում է էջը թարմացնելիս",
            ru: "Колонка «Доставлено» очищается при обновлении страницы",
            en: "The Delivered column clears when the page is reloaded"
        },
        today: {
            am: "Այսօր",
            ru: "Сегодня",
            en: "Today"
        },
        all: {
            am: "Բոլորը",
            ru: "Все",
            en: "All"
        },
        scope: {
            am: "Ժամանակահատված",
            ru: "Период",
            en: "Date range"
        },
        activeOrders: {
            am: "Ակտիվ պատվերներ",
            ru: "Активные заказы",
            en: "Active orders"
        },
        ordersShort: {
            am: "պատվեր",
            ru: "зак.",
            en: "orders"
        },
        newLabel: {
            am: "Նոր",
            ru: "Новый",
            en: "New"
        },
        more: {
            am: "ևս",
            ru: "ещё",
            en: "more"
        },
        portions: {
            am: "բաժին",
            ru: "порц.",
            en: "portions"
        },
        moveTo: {
            am: "Տեղափոխել",
            ru: "Переместить в",
            en: "Move to"
        },
        undo: {
            am: "Հետարկել",
            ru: "Отменить",
            en: "Undo"
        },
        empty: {
            am: "Ակտիվ պատվերներ չկան",
            ru: "Нет активных заказов",
            en: "No active orders"
        },
        emptyToday: {
            am: "Այսօրվա համար ակտիվ պատվերներ չկան",
            ru: "На сегодня нет активных заказов",
            en: "No active orders for today"
        },
        timeFilter: {
            am: "Ժամ",
            ru: "Время",
            en: "Time"
        },
        emptyTime: {
            am: "Այս ժամին պատվերներ չկան",
            ru: "Нет заказов на это время",
            en: "No orders at this time"
        },
    },
    orderPage: {
        newOrdersArrived: {
            am: "Նոր պատվերներ են եկել",
            ru: "Поступили новые заказы",
            en: "New orders arrived"
        },
        refreshList: {
            am: "Թարմացնել",
            ru: "Обновить",
            en: "Refresh"
        },
        noDataFound: {
            am: "Տվյալներ չեն գտնվել",
            ru: "Данные не найдены",
            en: "No data found"
        },
        declineOrderConfirmation: {
            am: "Մերժե՞լ պատվերը",
            ru: "Отклонить заказ?",
            en: "Decline Order?"
        },
        orderNumber: {
            am: "Պատվերի համարը",
            ru: "Номер заказа",
            en: "Order Number"
        },
        payment: {
            am: "Վճարը",
            ru: "Плата",
            en: "Payment"
        },
        title: {
            am: "Պատվերներ",
            ru: "Заказы",
            en: "Orders"
        },
        ongoingOrders: {
            am: "Մշակվող պատվերներ",
            ru: "Текущие заказы",
            en: "Ongoing Orders"
        },
        history: {
            am: "Պատմություն",
            ru: "История",
            en: "History"
        },
        dishes: {
            am: "Ուտեստներ",
            ru: "Блюда",
            en: "Dishes"
        },
        ongoingSubOrders: {
            am: "Պատվերներ",
            ru: "Заказы",
            en: "Orders"
        },
        ongoingSubDishes: {
            am: "Ուտեստներ",
            ru: "Блюда",
            en: "Dishes"
        },
        noCompany: {
            am: "Առանց ընկերության",
            ru: "Без компании",
            en: "No company"
        },
        dishPiecesTotal: {
            am: "Քանակ",
            ru: "Порций",
            en: "Pieces"
        },
        viewFullOrder: {
            am: "Տեսնել ամբողջ պատվերը",
            ru: "Посмотреть весь заказ",
            en: "View Full Order"
        },
        orderDeliveryDate: {
            am: "Պատվերի հանձնման օր",
            ru: "Дата доставки заказа",
            en: "Order Delivery Date"
        },
        shippingAddress: {
            am: "Առաքման հասցե",
            ru: "Адрес доставки",
            en: "Shipping Address"
        },
        paidWith: {
            am: "Վճարում",
            ru: "Оплата",
            en: "Payment method"
        },
        card: {
            am: "Քարտով",
            ru: "Картой",
            en: "Card"
        },
        card_on_delivery: {
            am: "Քարտով առաքման ժամանակ",
            ru: "Картой курьеру",
            en: "Card on delivery"
        },
        idram: {
            am: "Իդրամով",
            ru: "Идрам",
            en: "Idram"
        },
        telcell: {
            am: "Telcell",
            ru: "Telcell",
            en: "Telcell"
        },
        fastshift: {
            am: "FastShift",
            ru: "FastShift",
            en: "FastShift"
        },
        paylink: {
            am: "PayLink",
            ru: "PayLink",
            en: "PayLink"
        },
        cash: {
            am: "Կանխիկ",
            ru: "Наличными",
            en: "Cash"
        },
        b2b: {
            am: "B2B",
            ru: "B2B",
            en: "B2B"
        },
        noOrders: {
            am: "Պատվերներ չկան",
            ru: "Нет заказов",
            en: "No orders"
        },
        showing: {
            am: "Ցուցադրվում է",
            ru: "Показано",
            en: "Showing"
        },
        of: {
            am: "ից",
            ru: "из",
            en: "of"
        },
        orders: {
            am: "պատվերներ",
            ru: "заказы",
            en: "orders"
        },
        clearFilters: {
            am: "Մաքրել ֆիլտրերը",
            ru: "Очистить фильтры",
            en: "Clear filters"
        },
        resetFilters: {
            am: "Վերականգնել ֆիլտրերը",
            ru: "Сбросить фильтры",
            en: "Reset filters"
        },
        filtersApplyToCurrentPage: {
            am: "Ֆիլտրերը կիրառվում են միայն ընթացիկ էջի արդյունքների վրա։",
            ru: "Фильтры применяются только к текущей странице результатов.",
            en: "Filters apply to the current page of results only."
        },
        companyOptionsFromPage: {
            am: "Ընկերությունների ցանկը կարող է ցույց տալ միայն ընթացիկ էջում երևացող ընկերությունները։",
            ru: "Список компаний может показывать только компании с текущей страницы.",
            en: "Company names shown are only those present on the current page."
        },
        createdAt: {
            am: "Ստեղծման ամսաթիվ",
            ru: "Дата создания",
            en: "Created"
        },
        totalPrice: {
            am: "Ընդհանուր գումար",
            ru: "Общая сумма",
            en: "Total Price"
        },
        status: {
            am: "Կարգավիճակ",
            ru: "Статус",
            en: "Status"
        },
        paymentStatus: {
            am: "Վճարման կարգավիճակ",
            ru: "Статус оплаты",
            en: "Payment status"
        },
        company: {
            am: "Ընկերություն",
            ru: "Компания",
            en: "Company"
        },
        customer: {
            am: "Հաճախորդ",
            ru: "Клиент",
            en: "Customer"
        },
        allCompanies: {
            am: "Բոլոր ընկերությունները",
            ru: "Все компании",
            en: "All Companies"
        },
        deliveryDateFrom: {
            am: "Առաքման ամսաթիվ (սկիզբ)",
            ru: "Дата доставки (с)",
            en: "Delivery from"
        },
        deliveryDateTo: {
            am: "Առաքման ամսաթիվ (վերջ)",
            ru: "Дата доставки (по)",
            en: "Delivery to"
        },
        deliveryTimeRange: {
            am: "Առաքման ժամանակ",
            ru: "Время доставки",
            en: "Delivery time"
        },
        ongoingDeliveryDate: {
            am: "Առաքման ամսաթիվ",
            ru: "Дата доставки",
            en: "Delivery date"
        },
        ongoingDateScopeAll: {
            am: "Բոլորը",
            ru: "Все",
            en: "All"
        },
        timeRangeMorning: {
            am: "00:00–13:00",
            ru: "00:00–13:00",
            en: "00:00–13:00"
        },
        timeRangeAfternoon: {
            am: "13:00–17:00",
            ru: "13:00–17:00",
            en: "13:00–17:00"
        },
        timeRangeEvening: {
            am: "18:00–00:00",
            ru: "18:00–00:00",
            en: "18:00–00:00"
        },
        timeRangeWholeDay: {
            am: "Ամբողջ օրը",
            ru: "Весь день",
            en: "Whole day"
        },
        orderStatusFilter: {
            am: "Պատվերի կարգավիճակ",
            ru: "Статус заказа",
            en: "Order status"
        },
        allOrderStatuses: {
            am: "Բոլոր կարգավիճակները",
            ru: "Все статусы",
            en: "All statuses"
        },
        searchOrderNumber: {
            am: "Որոնել ըստ համարի",
            ru: "Поиск по номеру",
            en: "Search by order number"
        },
        filtersRegion: {
            am: "Պատվերների ֆիլտրեր",
            ru: "Фильтры заказов",
            en: "Order filters"
        },
        listFiltersTitle: {
            am: "Ֆիլտրեր",
            ru: "Фильтры",
            en: "Filters"
        },
        applyFilters: {
            am: "Կիրառել",
            ru: "Применить",
            en: "Apply"
        },
        resetAllFilters: {
            am: "Լռելյայնին վերադարձնել",
            ru: "Сбросить все фильтры",
            en: "Reset all"
        },
        openListFilters: {
            am: "Բացել պատվերի ֆիլտրերը",
            ru: "Открыть фильтры заказов",
            en: "Open order filters"
        }
    },

    // Order content page
    orderContentPage: {
        receipts: {
            am: "Կտրոններ",
            ru: "Чеки",
            en: "Receipts"
        },
        addReceipt: {
            am: "Ավելացնել կտրոն",
            ru: "Добавить чек",
            en: "Add receipt"
        },
        noReceipts: {
            am: "Կտրոններ չկան",
            ru: "Чеков нет",
            en: "No receipts"
        },
        replace: {
            am: "Փոխարինել",
            ru: "Заменить",
            en: "Replace"
        },
        paymentStatus: {
            am: "Վճարում",
            ru: "Оплата",
            en: "Payment"
        },
        chatWithCustomer: {
            am: "Գրել հաճախորդին",
            ru: "Написать клиенту",
            en: "Chat with customer"
        },
        order: {
            am: "Պատվեր",
            ru: "Заказ",
            en: "Order"
        },
        notes: {
            am: "Նշումներ",
            ru: "Заметки",
            en: "Notes"
        },
        backToList: {
            am: "Վերդառնալ նախորդ էջ",
            ru: "Вернуться на предыдущую страницу",
            en: "Back to previous page"
        },
        copyOrderId: {
            am: "Պատճենել պատվերի ID-ն",
            ru: "Скопировать ID заказа",
            en: "Copy order ID"
        },
        transactionDate: {
            am: "Պատվերը տեղադրվել է",
            ru: "Заказ размещен",
            en: "Order placed on"
        },
        orderedDishes: {
            am: "Պատվիրված ուտեստներ",
            ru: "Заказанные блюда",
            en: "Ordered Dishes"
        },
        additions: {
            am: "Հավելումներ",
            ru: "Дополнения",
            en: "Additions"
        },
        deliveryAmount: {
            am: "Առաքման գումար",
            ru: "Стоимость доставки",
            en: "Delivery Amount"
        },
        total: {
            am: "Ընդհանուր",
            ru: "Итого",
            en: "Total"
        },
        totalWithDiscount: {
            am: "Օգտատիրոջ կողմից վճարվելիք գումար",
            ru: "Итого взять",
            en: "Total to take"
        },
        discountAmount: {
            am: "Զեղչ",
            ru: "Скидка",
            en: "Discount"
        },
        additionalInfo: {
            am: "Հավելյալ ինֆորմացիա",
            ru: "Дополнительная информация",
            en: "Additional Information"
        },
        email: {
            am: "Էլ. հասցե",
            ru: "Эл. почта",
            en: "Email"
        },
        phoneNumber: {
            am: "Հեռախոսահամար",
            ru: "Номер телефона",
            en: "Phone Number"
        },
        customer: {
            am: "Հաճախորդ",
            ru: "Клиент",
            en: "Customer"
        },
        scheduledDate: {
            am: "Նախատեսված ամսաթիվ",
            ru: "Запланированная дата",
            en: "Scheduled Date"
        },
        scheduledTime: {
            am: "Նախատեսված ժամ",
            ru: "Запланированное время",
            en: "Scheduled Time"
        },
        address: {
            am: "Հասցե",
            ru: "Адрес",
            en: "Address"
        },
        country: {
            am: "Երկիր",
            ru: "Страна",
            en: "Country"
        },
        city: {
            am: "Քաղաք",
            ru: "Город",
            en: "City"
        },
        street: {
            am: "Փողոց",
            ru: "Улица",
            en: "Street"
        },
        home: {
            am: "Տուն/Բնակարան",
            ru: "Дом/Квартира",
            en: "Home/Apartment"
        },
        floor: {
            am: "Հարկ",
            ru: "Этаж",
            en: "Floor"
        },
        entrance: {
            am: "Մուտք",
            ru: "Вход",
            en: "Entrance"
        },
        flat: {
            am: "Առաստաղ",
            ru: "Квартира",
            en: "Apartment"
        },
        viewOnMap: {
            am: "Տեսնել քարտեզի վրա",
            ru: "Посмотреть на карте",
            en: "View on Map"
        },
        orderNotFound: {
            am: "Պատվերը չի գտնվել",
            ru: "Заказ не найден",
            en: "Order not found"
        }
        ,
        takeaway: {
            am: "Հաճախորդը կվերցնի",
            ru: "Самовывоз",
            en: "Takeaway"
        },
        delivery: {
            am: "Առաքում",
            ru: "Доставка",
            en: "Delivery"
        },
        promocode: {
            am: "Պրոմոկոդ",
            ru: "Промокод",
            en: "Promocode"
        },
        deliveryWay: {
            am: "Պատվերի ստացում",
            ru: "Способ получения",
            en: "Receiving method"
        },
        asSoonAsPossible: {
            am: "Հնարավորինս արագ",
            ru: "Клиент ожидает доставку как можно скорее",
            en: "Customer expects delivery as soon as possible"
        },
        asapShort: {
            am: "Շուտ",
            ru: "Срочно",
            en: "ASAP"
        }
    },

    // Order modal
    orderModal: {
        selectReason: {
            am: "Ընտրեք պատճառը",
            ru: "Выберите причину",
            en: "Select the reason below"
        },
        close: {
            am: "Փակել",
            ru: "Закрыть",
            en: "Close"
        },
        submit: {
            am: "Հաստատել",
            ru: "Подтвердить",
            en: "Submit"
        },
        preparationTimeIssue: {
            am: "Պատրաստման հետ կապված խնդիր",
            ru: "Проблема со временем приготовления",
            en: "Preparation Time Issue"
        },
        ingredientsOutOfStock: {
            am: "Որոշ բաղադրիչներ սպառվել են",
            ru: "Некоторые ингредиенты закончились",
            en: "Some Ingredients are Out of Stock"
        },
        deliveryIssue: {
            am: "Պատվերը ժամանակի հասցնելու խնդիր",
            ru: "Проблема с своевременной доставкой",
            en: "Issue with Timely Delivery"
        },
        other: {
            am: "Այլ",
            ru: "Другое",
            en: "Other"
        },
        enterReasonHere: {
            am: "Մուտքագրեք ձեր պատճառն այստեղ...",
            ru: "Введите вашу причину здесь...",
            en: "Enter your reason here..."
        }
    },

    // Pagination
    pagination: {
        previous: {
            am: "Նախորդ",
            ru: "Предыдущий",
            en: "Previous"
        },
        next: {
            am: "Հաջորդ",
            ru: "Следующий",
            en: "Next"
        }
    },

    // Menu page
    menuPage: {
        title: {
            am: "Մենյու",
            ru: "Меню",
            en: "Menu"
        },
        backToList: {
            am: "Վերդառնալ նախորդ էջ",
            ru: "Вернуться на предыдущую страницу",
            en: "Back to previous page"
        }
    },

    // Days of week
    days: {
        monday: {
            am: "Երկուշաբթի",
            ru: "Понедельник",
            en: "Monday"
        },
        tuesday: {
            am: "Երեքշաբթի",
            ru: "Вторник",
            en: "Tuesday"
        },
        wednesday: {
            am: "Չորեքշաբթի",
            ru: "Среда",
            en: "Wednesday"
        },
        thursday: {
            am: "Հինգշաբթի",
            ru: "Четверг",
            en: "Thursday"
        },
        friday: {
            am: "Ուրբաթ",
            ru: "Пятница",
            en: "Friday"
        },
        saturday: {
            am: "Շաբաթ",
            ru: "Суббота",
            en: "Saturday"
        },
        sunday: {
            am: "Կիրակի",
            ru: "Воскресенье",
            en: "Sunday"
        }
    },
    // Months
    months: {
        january: {
            am: "Հունվար",
            ru: "Январь",
            en: "January"
        },
        february: {
            am: "Փետրվար",
            ru: "Февраль",
            en: "February"
        },
        march: {
            am: "Մարտ",
            ru: "Март",
            en: "March"
        },
        april: {
            am: "Ապրիլ",
            ru: "Апрель",
            en: "April"
        },
        may: {
            am: "Մայիս",
            ru: "Май",
            en: "May"
        },
        june: {
            am: "Հունիս",
            ru: "Июнь",
            en: "June"
        },
        july: {
            am: "Հուլիս",
            ru: "Июль",
            en: "July"
        },
        august: {
            am: "Օգոստոս",
            ru: "Август",
            en: "August"
        },
        september: {
            am: "Սեպտեմբեր",
            ru: "Сентябрь",
            en: "September"
        },
        october: {
            am: "Հոկտեմբեր",
            ru: "Октябрь",
            en: "October"
        },
        november: {
            am: "Նոյեմբեր",
            ru: "Ноябрь",
            en: "November"
        },
        december: {
            am: "Դեկտեմբեր",
            ru: "Декабрь",
            en: "December"
        }
    },

    // Spice levels
    spiceLevels: {
        notSpicy: {
            am: "Ոչ կծու",
            ru: "Не острый",
            en: "Not spicy"
        },
        mildSpicy: {
            am: "Մեղմ կծու",
            ru: "Слабо острый",
            en: "Mild spicy"
        },
        mediumSpicy: {
            am: "Միջին կծու",
            ru: "Средне острый",
            en: "Medium spicy"
        },
        spicy: {
            am: "Կծու",
            ru: "Острый",
            en: "Spicy"
        }
    },

    // Language names
    languages: {
        armenian: {
            am: "Հայերեն",
            ru: "Армянский",
            en: "Armenian"
        },
        russian: {
            am: "Ռուսերեն",
            ru: "Русский",
            en: "Russian"
        },
        english: {
            am: "Անգլերեն",
            ru: "Английский",
            en: "English"
        },
        active: {
            am: "Ակտիվ",
            ru: "Активный",
            en: "Active"
        }
    },

    // Login page
    login: {
        title: {
            am: "Մուտք գործել",
            ru: "Вход в систему",
            en: "Login"
        },
        enterCode: {
            am: "Մուտքագրեք ձեր կոդը",
            ru: "Введите ваш код",
            en: "Enter your code"
        },
        loginButton: {
            am: "Մուտք գործել",
            ru: "Войти",
            en: "Login"
        },
        invalidCode: {
            am: "Սխալ կոդ, փորձեք կրկին",
            ru: "Неверный код, попробуйте еще раз",
            en: "Invalid code, please try again"
        }
    },

    // Profile page
    profile: {
        noData: {
            am: "Պրոֆիլի տվյալները հասանելի չեն",
            ru: "Данные профиля недоступны",
            en: "No profile data available"
        },
        personal: {
            am: "Անձնական",
            ru: "Личные",
            en: "Personal"
        },
        legal: {
            am: "Ռեկվիզիտներ",
            ru: "Реквизиты",
            en: "Requisites"
        },
        personalData: {
            am: "Անձնական տվյալները",
            ru: "Личные данные",
            en: "Personal Data"
        },
        basicInformation: {
            am: "Հիմնական տեղեկություններ",
            ru: "Основная информация",
            en: "Basic Information"
        },
        fullNameAm: {
            am: "Անուն Ազգանուն (AM)",
            ru: "Имя Фамилия (AM)",
            en: "Full Name (AM)"
        },
        fullNameAmPlaceholder: {
            am: "Հայերեն Անուն Ազգանուն",
            ru: "Имя Фамилия на армянском",
            en: "Armenian Full Name"
        },
        email: {
            am: "Էլ հասցե",
            ru: "Эл. почта",
            en: "Email"
        },
        emailPlaceholder: {
            am: "Մուտքագրեք էլ հասցեն",
            ru: "Введите эл. почту",
            en: "Enter email address"
        },
        username: {
            am: "Օգտանուն",
            ru: "Имя пользователя",
            en: "Username"
        },
        usernamePlaceholder: {
            am: "օր. side-chick.bychef.am",
            ru: "напр. side-chick.bychef.am",
            en: "e.g. side-chick.bychef.am"
        },
        link: {
            am: "Հղում",
            ru: "Ссылка",
            en: "Link"
        },
        linkPlaceholder: {
            am: "yourbusiness",
            ru: "yourbusiness",
            en: "yourbusiness"
        },
        linkRequired: {
            am: "Հղումը պարտադիր է, երբ մասնավոր դոմեյնը միացված է",
            ru: "Ссылка обязательна, когда включен приватный домен",
            en: "Link is required when Private Domain is enabled"
        },
        description: {
            am: "Նկարագրություն",
            ru: "Описание",
            en: "Description"
        },
        descriptionAm: {
            am: "Նկարագրություն (Հայերեն)",
            ru: "Описание (Армянский)",
            en: "Description (Armenian)"
        },
        descriptionAmPlaceholder: {
            am: "Նկարագրություն Հայերեն",
            ru: "Описание на армянском",
            en: "Description in Armenian"
        },
        descriptionRu: {
            am: "Նկարագրություն (Ռուսերեն)",
            ru: "Описание (Русский)",
            en: "Description (Russian)"
        },
        descriptionRuPlaceholder: {
            am: "Նկարագրություն Ռուսերեն",
            ru: "Описание на русском",
            en: "Description in Russian"
        },
        descriptionEn: {
            am: "Նկարագրություն (Անգլերեն)",
            ru: "Описание (Английский)",
            en: "Description (English)"
        },
        descriptionEnPlaceholder: {
            am: "Նկարագրություն Անգլերեն",
            ru: "Описание на английском",
            en: "Description in English"
        },
        phoneNumber: {
            am: "Հեռախոսահամար",
            ru: "Номер телефона",
            en: "Phone Number"
        },
        phoneNumberPlaceholder: {
            am: "Մուտքագրեք հեռախոսահամար",
            ru: "Введите номер телефона",
            en: "Enter phone number"
        },
        address: {
            am: "Հասցե",
            ru: "Адрес",
            en: "Address"
        },
        addressPlaceholder: {
            am: "Մուտքագրեք հասցեն",
            ru: "Введите адрес",
            en: "Enter address"
        },
        domofon: {
            am: "Դոմոֆոն",
            ru: "Домофон",
            en: "Intercom"
        },
        domofonPlaceholder: {
            am: "Մուտքագրեք դոմոֆոն",
            ru: "Введите домофон",
            en: "Enter intercom"
        },
        searchAddress: {
            am: "Փնտրել հասցե",
            ru: "Поиск адреса",
            en: "Search address"
        },
        searchAddressPlaceholder: {
            am: "Մուտքագրեք հասցե",
            ru: "Введите адрес",
            en: "Enter address"
        },
        region: {
            am: "Մարզ",
            ru: "Область",
            en: "Region"
        },
        regionPlaceholder: {
            am: "Ընտրեք մարզ",
            ru: "Выберите область",
            en: "Select region"
        },
        residence: {
            am: "Բնակավայր",
            ru: "Населенный пункт",
            en: "Residence"
        },
        residencePlaceholder: {
            am: "Մուտքագրեք բնակավայր",
            ru: "Введите населенный пункт",
            en: "Enter residence"
        },
        country: {
            am: "Երկիր",
            ru: "Страна",
            en: "Country"
        },
        street: {
            am: "Փողոց",
            ru: "Улица",
            en: "Street"
        },
        streetPlaceholder: {
            am: "Մուտքագրեք փողոցը",
            ru: "Введите улицу",
            en: "Enter street"
        },
        home: {
            am: "Տուն",
            ru: "Дом",
            en: "Home"
        },
        homePlaceholder: {
            am: "Մուտքագրեք տան համարը",
            ru: "Введите номер дома",
            en: "Enter home number"
        },
        flat: {
            am: "Բնակարան",
            ru: "Квартира",
            en: "Apartment"
        },
        flatPlaceholder: {
            am: "Մուտքագրեք բնակարան",
            ru: "Введите квартиру",
            en: "Enter apartment"
        },
        floor: {
            am: "Հարկ",
            ru: "Этаж",
            en: "Floor"
        },
        floorPlaceholder: {
            am: "Մուտքագրեք հարկ",
            ru: "Введите этаж",
            en: "Enter floor"
        },
        entrance: {
            am: "Մուտք",
            ru: "Вход",
            en: "Entrance"
        },
        entrancePlaceholder: {
            am: "Մուտքագրեք մուտք",
            ru: "Введите вход",
            en: "Enter entrance"
        },
        selectOnMap: {
            am: "Ընտրել քարտեզի վրա",
            ru: "Выбрать на карте",
            en: "Select on map"
        },
        selectAddressOnMap: {
            am: "Ընտրեք հասցեն քարտեզի վրա",
            ru: "Выберите адрес на карте",
            en: "Select address on map"
        },
        selectAddress: {
            am: "Ընտրեք հասցե",
            ru: "Выберите адрес",
            en: "Select Address"
        },
        coordinates: {
            am: "Կոորդինատներ",
            ru: "Координаты",
            en: "Coordinates"
        },
        confirm: {
            am: "Հաստատել",
            ru: "Подтвердить",
            en: "Confirm"
        },
        addressNotFound: {
            am: "Հասցեն չի գտնվել",
            ru: "Адрес не найден",
            en: "Address not found"
        },
        loadingMap: {
            am: "Բեռնվում է քարտեզը...",
            ru: "Загрузка карты...",
            en: "Loading map..."
        },
        socialLinksAndBranding: {
            am: "Սոցիալական հղումներ ԵՎ Բրենդավորում",
            ru: "Социальные ссылки и брендинг",
            en: "Social Links and Branding"
        },
        addPhoto: {
            am: "Ավելացրեք լուսանկար",
            ru: "Добавить фото",
            en: "Add Photo"
        },
        logo: {
            am: "Լոգո",
            ru: "Логотип",
            en: "Logo"
        },
        banner: {
            am: "Բաններ",
            ru: "Баннер",
            en: "Banner"
        },
        noImage: {
            am: "Նկար չկա",
            ru: "Нет изображения",
            en: "No image"
        },
        changeImage: {
            am: "Փոխել նկարը",
            ru: "Изменить изображение",
            en: "Change image"
        },
        uploadImage: {
            am: "Վերբեռնել նկար",
            ru: "Загрузить изображение",
            en: "Upload image"
        },
        pageName: {
            am: "Էջի անվանում",
            ru: "Название страницы",
            en: "Page Name"
        },
        pageNameAm: {
            am: "Էջի անվանում (Հայերեն)",
            ru: "Название страницы (Армянский)",
            en: "Page Name (Armenian)"
        },
        pageNameAmPlaceholder: {
            am: "Օրինակ՝ Միլենա Սվիթ",
            ru: "Например: Милена Свит",
            en: "Example: Milena Sweet"
        },
        pageNameRu: {
            am: "Էջի անվանում (Ռուսերեն)",
            ru: "Название страницы (Русский)",
            en: "Page Name (Russian)"
        },
        pageNameRuPlaceholder: {
            am: "Օրինակ՝ Милена Свит",
            ru: "Например: Милена Свит",
            en: "Example: Milena Sweet"
        },
        pageNameEn: {
            am: "Էջի անվանում (Անգլերեն)",
            ru: "Название страницы (Английский)",
            en: "Page Name (English)"
        },
        pageNameEnPlaceholder: {
            am: "Օրինակ՝ Milena Sweet",
            ru: "Например: Milena Sweet",
            en: "Example: Milena Sweet"
        },
        kitchenName: {
            am: "Խոհանոցի անվանում",
            ru: "Название кухни",
            en: "Kitchen Name"
        },
        kitchenNamePlaceholder: {
            am: "Օրինակ՝ Միլենա Սվիթ",
            ru: "Например: Милена Свит",
            en: "Example: Milena Sweet"
        },
        selectDietType: {
            am: "Ընտրել պրոֆիլի թեգեր",
            ru: "Выбрать теги для профиля",
            en: "Select Profile Tags"
        },
        selectFromList: {
            am: "Ընտրել ցանկից",
            ru: "Выбрать из списка",
            en: "Select from the list"
        },
        socialLinks: {
            am: "Սոցիալական Հղումներ",
            ru: "Социальные ссылки",
            en: "Social Links"
        },
        enterSocialUrl: {
            am: "Մուտքագրեք {platform} URL",
            ru: "Введите {platform} URL",
            en: "Enter {platform} URL"
        },
        unsavedChanges: {
            am: "Չպահպանված փոփոխություններ",
            ru: "Несохраненные изменения",
            en: "Unsaved changes"
        },
        logoRequired: {
            am: "Լոգոն պարտադիր է և չի կարող ջնջվել",
            ru: "Логотип обязателен и не может быть удален",
            en: "Logo is required and cannot be deleted"
        },
        clickToView: {
            am: "Դիտել",
            ru: "Просмотр",
            en: "View"
        },
        updateSuccess: {
            am: "Տվյալները հաջողությամբ թարմացվել են!",
            ru: "Данные успешно обновлены!",
            en: "Data updated successfully!"
        },
        updateError: {
            am: "Սխալ թարմացման ընթացքում",
            ru: "Ошибка при обновлении",
            en: "Error during update"
        },
        legalName: {
            am: "Իրավաբանական անվանում",
            ru: "Юридическое наименование",
            en: "Legal Entity Name"
        },
        legalNameAm: {
            am: "Իրավաբանական անվանում (Հայերեն)",
            ru: "Юридическое наименование (Армянский)",
            en: "Legal Entity Name (Armenian)"
        },
        legalNameRu: {
            am: "Իրավաբանական անվանում (Ռուսերեն)",
            ru: "Юридическое наименование (Русский)",
            en: "Legal Entity Name (Russian)"
        },
        legalNameEn: {
            am: "Իրավաբանական անվանում (Անգլերեն)",
            ru: "Юридическое наименование (Английский)",
            en: "Legal Entity Name (English)"
        },
        legalNameAmPlaceholder: {
            am: "Օրինակ. Ա/Ձ Արմեն Արմենյան",
            ru: "Например: ИП Армен Арменян",
            en: "Example: IE Armen Armenyan"
        },
        bankAccount: {
            am: "Բանկային հաշվեհամար",
            ru: "Банковский счет",
            en: "Bank Account"
        },
        bankAccountPlaceholder: {
            am: "Մուտքագրեք բանկային հաշվեհամարը",
            ru: "Введите банковский счет",
            en: "Enter bank account"
        },
        taxInfo: {
            am: "Հարկային տեղեկատվություն",
            ru: "Налоговая информация",
            en: "Tax Information"
        },
        tin: {
            am: "ՀՎՀՀ",
            ru: "ИНН",
            en: "TIN"
        },
        taxNumberPlaceholder: {
            am: "Մուտքագրեք հարկային համարը",
            ru: "Введите налоговый номер",
            en: "Enter tax number"
        },
        addressInfo: {
            am: "Հասցեի տեղեկատվություն",
            ru: "Информация об адресе",
            en: "Address Information"
        },
        city: {
            am: "Քաղաք",
            ru: "Город",
            en: "City"
        },
        homeApartment: {
            am: "Տուն/Բնակարան",
            ru: "Дом/Квартира",
            en: "Home/Apartment"
        },
        homeNumberPlaceholder: {
            am: "Մուտքագրեք տան համարը",
            ru: "Введите номер дома",
            en: "Enter home number"
        },
        contactAdminToChange: {
            am: "Տվյալները փոխելու համար խնդրում ենք կապնվել ադմինների հետ։",
            ru: "Для изменения данных, пожалуйста, свяжитесь с администраторами.",
            en: "To change the data, please contact the administrators."
        },
        invalidFile: {
            am: "Անվավեր ֆայլ: Խնդրում ենք ընտրել վավեր նկարի ֆայլ:",
            ru: "Неверный файл. Пожалуйста, выберите действительный файл изображения.",
            en: "Invalid file. Please select a valid image file."
        },
        labelsError: {
            am: "Սխալ պիտակներ",
            ru: "Ошибка меток",
            en: "Labels error"
        },
        telegramIds: {
            am: "Telegram ID-ներ",
            ru: "Telegram ID",
            en: "Telegram IDs"
        },
        telegramId: {
            am: "Telegram ID",
            ru: "Telegram ID",
            en: "Telegram ID"
        },
        addTelegramId: {
            am: "Ավելացնել Telegram ID",
            ru: "Добавить Telegram ID",
            en: "Add Telegram ID"
        },
        removeTelegramId: {
            am: "Հեռացնել Telegram ID",
            ru: "Удалить Telegram ID",
            en: "Remove Telegram ID"
        },
        lastTelegramIdCannotBeRemoved: {
            am: "Վերջին Telegram ID-ն չի կարող հեռացվել",
            ru: "Последний Telegram ID не может быть удален",
            en: "The last Telegram ID cannot be removed"
        },
        telegramIdPlaceholder: {
            am: "Մուտքագրեք Telegram ID",
            ru: "Введите Telegram ID",
            en: "Enter Telegram ID"
        }
    },

    payments: {
        totalRevenue: {
            am: "Ընդհանուր եկամուտներ",
            ru: "Общий доход",
            en: "Total Revenue"
        },
        transactions: {
            am: "Գործարքներ",
            ru: "Транзакции",
            en: "Transactions"
        },
        selectDate: {
            am: "Ընտրել ամսաթիվ",
            ru: "Выбрать дату",
            en: "Select Date"
        },
        date: {
            am: "Ամսաթիվ",
            ru: "Дата",
            en: "Date"
        },
        orderNumber: {
            am: "Պատվերի համար",
            ru: "Номер заказа",
            en: "Order Number"
        },
        amount: {
            am: "Գումար",
            ru: "Сумма",
            en: "Amount"
        },
        platformFee: {
            am: "Պլատֆորմի վճար",
            ru: "Комиссия платформы",
            en: "Platform Fee"
        },
        partialPayment: {
            am: "Մասնակի փոխանցում (կիրառվում է պրոմոկոդերի ժամանակ)",
            ru: "Частичный перевод (применяется при использовании промокодов)",
            en: "Partial transfer (applies when using promo codes)"
        },
        tax: {
            am: "Հարկ",
            ru: "Налог",
            en: "Tax"
        },
        paymentType: {
            am: "Մեթոդ",
            ru: "Метод оплаты",
            en: "Payment Method"
        },
        platformEarning: {
            am: "Պլատֆորմի եկամուտ",
            ru: "Доход платформы",
            en: "Platform Earning"
        },
        chefEarning: {
            am: "Վաճառողի եկամուտ",
            ru: "Доход шефа",
            en: "Chef Earning"
        },
        promoApplied: {
            am: "Պրոմոկոդ կիրառված",
            ru: "Промокод применен",
            en: "Promo Applied"
        },
        discountedPrice: {
            am: "Զեղչված գին",
            ru: "Цена со скидкой",
            en: "Discounted Price"
        },
        totalPriceBeforeDiscount: {
            am: "Գին մինչև զեղչ",
            ru: "Цена до скидки",
            en: "Total Before Discount"
        },
        deliveryPrice: {
            am: "Առաքման արժեք",
            ru: "Стоимость доставки",
            en: "Delivery Price"
        },
        status: {
            am: "Կարգավիճակ",
            ru: "Статус",
            en: "Status"
        },
        noTransactions: {
            am: "Գործարքներ չկան",
            ru: "Нет доступных транзакций",
            en: "No transactions available"
        },
        cash: {
            am: "Կանխիկ",
            ru: "Наличные",
            en: "Cash"
        },
        nonCash: {
            am: "Անկանխիկ",
            ru: "Безналичные",
            en: "Non-cash"
        },
        all: {
            am: "Բոլորը",
            ru: "Все",
            en: "All"
        },
        chef: {
            am: "Վաճառող եկամուտ:",
            ru: "Шеф :",
            en: "Chef Earning:"
        },
        platform: {
            am: "Պլատֆորմ:",
            ru: "Платформа:",
            en: "Platform:"
        },
        totalOrderPrice: {
            am: "Ընդհանուր պատվերի արժեք",
            ru: "Общая стоимость заказов",
            en: "Total Order Price"
        },
        cashNonCash: {
            am: "Կանխիկ / Անկանխիկ",
            ru: "Наличные / Безналичные",
            en: "Cash / Non-cash"
        },
        chefPlatform: {
            am: "Վաճառող / Պլատֆորմ",
            ru: "Шеф / Платформа",
            en: "Chef / Platform"
        },
        netCashChefKeeps: {
            am: "Զուտ կանխիկ վաճառողի մոտ",
            ru: "Чистые наличные у шефа",
            en: "Net Cash Chef Keeps"
        },
        regularTransfer: {
            am: "Կանոնավոր փոխանցում",
            ru: "Регулярный перевод",
            en: "Regular Transfer"
        },
        discountCompensation: {
            am: "Զեղչի փոխհատուցում",
            ru: "Компенсация скидки",
            en: "Discount Compensation"
        },
        yandexCompensation: {
            am: "Yandex առաքման փոխհատուցում",
            ru: "Yandex компенсация доставки",
            en: "Yandex Delivery Compensation"
        },
        yandexCompensationDesc: {
            am: "Yandex առաքման վճարների փոխհատուցում, որը կստանաք պլատֆորմից",
            ru: "Компенсация за доставку Yandex, которую вы получите от платформы",
            en: "Yandex delivery fee compensation you'll receive from the platform"
        },
        feesDiscounts: {
            am: "Հանձնակատարներ / Զեղչեր",
            ru: "Комиссии / Скидки",
            en: "Fees / Discounts"
        },
        selectDateShort: {
            am: "Ընտրել",
            ru: "Выбрать",
            en: "Select Date"
        },
        close: {
            am: "Փակել",
            ru: "Закрыть",
            en: "Close"
        },
        noTransactionsShort: {
            am: "Գործարքներ չկան",
            ru: "Нет транзакций",
            en: "No transactions"
        },
        comprehensiveBreakdown: {
            am: "Ամբողջական ֆինանսական վերլուծություն",
            ru: "Комплексный финансовый анализ",
            en: "Comprehensive Financial Breakdown"
        },
        breakdownDescription: {
            am: "Ծանուցարան ձեր եկամուտների և փոխանցումների մասին",
            ru: "Понимание ваших доходов и переводов",
            en: "Understanding your earnings and transfers"
        },
        totalOrderPriceDesc: {
            am: "Ամբողջ ծավալը, որը հաճախորդները վճարել են ձեր պատվերների համար այս ժամանակահատվածում",
            ru: "Общая сумма, которую клиенты заплатили за ваши заказы в этот период",
            en: "Total amount customers paid for your orders during this period"
        },
        cashNonCashDesc: {
            am: "Ցույց է տալիս, թե ինչքանն են հաճախորդները վճարել կանխիկ և ինչքանն՝ անկանխիկ",
            ru: "Показывает, сколько клиенты заплатили наличными и сколько картой",
            en: "Shows how much customers paid in cash vs. card payments"
        },
        chefPlatformDesc: {
            am: "Ձեր եկամուտը հանած պլատֆորմի վճարը",
            ru: "Ваш доход за вычетом комиссии платформы",
            en: "Your earnings minus platform commission"
        },
        netCashChefKeepsDesc: {
            am: "Կանխիկ գումարը, որը պատվերներից մնացել է վաճառողի մոտ",
            ru: "Наличные деньги, которые вы можете оставить себе.",
            en: "Cash money, from orders"
        },
        regularTransferDesc: {
            am: "Ամսական հիմնական փոխանցումը՝ ներառելով ձեր անկանխիկ եկամուտները և փոխհատուցումները",
            ru: "Ежемесячный основной перевод, включающий ваши безналичные доходы и компенсации",
            en: "Monthly main transfer including your non-cash earnings and compensations"
        },
        discountCompensationDesc: {
            am: "Լրացուցիչ փոխանցում՝ կանխիկ պատվերների զեղչերի համար, որոնք պլատֆորմն է վճարում",
            ru: "Дополнительный перевод за скидки на наличные заказы, которые платит платформа",
            en: "Additional transfer for discounts on cash orders that the platform pays for"
        },
        feesDiscountsDesc: {
            am: "Պլատֆորմի հանձնակատարների և հաճախորդների զեղչերի ընդհանուր ցուցանիշները",
            ru: "Общие показатели комиссий платформы и скидок для клиентов",
            en: "Overview of platform commissions and customer discounts"
        },
        actualCashReceived: {
            am: "Իրականում ստացված կանխիկ",
            ru: "Фактически полученные наличные",
            en: "Actual Cash Received"
        },
        actualCashReceivedDesc: {
            am: "Փաստացի կանխիկ գումարը, որը ձեր ձեռքն է եկել հաճախորդներից այս ժամանակահատվածում",
            ru: "Фактические наличные деньги, которые попали к вам в руки от клиентов за этот период",
            en: "Actual cash money that came into your hands from customers during this period"
        },
        nonCashOrdersAmount: {
            am: "Անկանխիկ պատվերների գումարը",
            ru: "Сумма безналичных заказов",
            en: "Non-Cash Orders Amount"
        },
        nonCashOrdersAmountDesc: {
            am: "Գումարը, որը ստանալու եք բանկային փոխանցմամբ քարտային պատվերների համար",
            ru: "Сумма, которую вы получите банковским переводом за заказы по карте",
            en: "Amount you'll receive by bank transfer for card payment orders"
        },
        feeCompensationFromCash: {
            am: "Հանձնակատարի փոխհատուցում կանխիկից",
            ru: "Компенсация комиссии с наличных",
            en: "Fee Compensation From Cash"
        },
        feeCompensationFromCashDesc: {
            am: "Պլատֆորմի հանձնակատարը, որը կփոխհատուցվի ձեր կանխիկ վաճառքից",
            ru: "Комиссия платформы, которая будет компенсирована из ваших наличных продаж",
            en: "Platform commission that will be compensated from your cash sales"
        },
        totalDiscountsApplied: {
            am: "Ընդհանուր կիրառված զեղչեր",
            ru: "Всего применено скидок",
            en: "Total Discounts Applied"
        },
        totalDiscountsAppliedDesc: {
            am: "Հաճախորդներին տրված զեղչերի ընդհանուր գումարը՝ պրոմոկոդներով և այլն",
            ru: "Общая сумма скидок, предоставленных клиентам через промокоды и другие акции",
            en: "Total amount of discounts given to customers through promo codes and other offers"
        },
        totalDeliveryFees: {
            am: "Ընդհանուր առաքման վճարներ",
            ru: "Всего за доставку",
            en: "Total Delivery Fees"
        },
        totalDeliveryFeesDesc: {
            am: "Հաճախորդներից հավաքագրված առաքման վճարների ընդհանուր գումարը",
            ru: "Общая сумма платы за доставку, собранная с клиентов",
            en: "Total delivery fees collected from customers"
        },
        totalPlatformFees: {
            am: "Ընդհանուր պլատֆորմի վճարներ",
            ru: "Всего комиссий платформы",
            en: "Total Platform Fees"
        },
        totalPlatformFeesDesc: {
            am: "Պլատֆորմին վճարված ընդհանուր հանձնակատարը ձեր բոլոր պատվերների համար",
            ru: "Общая комиссия, выплаченная платформе за все ваши заказы",
            en: "Total commission paid to the platform for all your orders"
        },
        showMore: {
            am: "Ցույց տալ ավելին",
            ru: "Показать больше",
            en: "Show More"
        },
        showLess: {
            am: "Ցույց տալ ավելի քիչ",
            ru: "Показать меньше",
            en: "Show Less"
        },
        transferBreakdown: {
            am: "Փոխանցումների բաշխում",
            ru: "Разбивка переводов",
            en: "Transfer Breakdown"
        },
        detailedFinancialData: {
            am: "Մանրամասն ֆինանսական տվյալներ",
            ru: "Подробные финансовые данные",
            en: "Detailed Financial Data"
        },
        exportReport: {
            am: "Արտահանել հաշվետվություն",
            ru: "Экспорт отчета",
            en: "Export Report"
        },
        exporting: {
            am: "Արտահանվում է...",
            ru: "Экспорт...",
            en: "Exporting..."
        },
        exportSuccess: {
            am: "Հաշվետվությունը հաջողությամբ արտահանվեց",
            ru: "Отчет успешно экспортирован",
            en: "Report exported successfully"
        },
        exportError: {
            am: "Չհաջողվեց արտահանել հաշվետվությունը",
            ru: "Не удалось экспортировать отчет",
            en: "Failed to export report"
        },
        exportExcel: {
            am: "Արտահանել Excel-ով",
            ru: "Экспорт в Excel",
            en: "Export as Excel"
        },
        exportCSV: {
            am: "Արտահանել CSV-ով",
            ru: "Экспорт в CSV",
            en: "Export as CSV"
        },
        export: {
            am: "Արտահանել",
            ru: "Экспорт",
            en: "Export"
        },
        promoCodeApplied: {
            am: "Պրոմոկոդ կիրառված",
            ru: "Промокод применен",
            en: "Promo Code Applied"
        },
        selectDateRange: {
            am: "Խնդրում ենք ընտրել ամսաթվերի միջակայք",
            ru: "Пожалуйста, выберите диапазон дат",
            en: "Please select a date range"
        },
        noDataToExport: {
            am: "Արտահանման համար տվյալներ չկան",
            ru: "Нет данных для экспорта",
            en: "No payment data available for export"
        }
    },

    calendar: {
        previousMonth: {
            am: "Նախորդ ամիս",
            ru: "Предыдущий месяц",
            en: "Previous month"
        },
        nextMonth: {
            am: "Հաջորդ ամիս",
            ru: "Следующий месяц",
            en: "Next month"
        }
    },

    // Schedule page
    schedule: {
        title: {
            am: "Գրաֆիկ",
            ru: "Расписание",
            en: "Schedule"
        },
        workingDays: {
            am: "Աշխատանքային օրեր",
            ru: "Рабочие дни",
            en: "Working Days"
        },
        selectWorkingDays: {
            am: "Ընտրեք Ձեր աշխատանքային օրերն ու ժամերը։",
            ru: "Выберите ваши рабочие дни и часы.",
            en: "Select your working days and hours."
        },
        currentWorkingDays: {
            am: "Ընթացիկ աշխատանքային օրեր",
            ru: "Текущие рабочие дни",
            en: "Current Working Days"
        },
        noWorkingDays: {
            am: "Դեռ չկան ընտրված աշխատանքային օրեր",
            ru: "Рабочие дни еще не выбраны",
            en: "No working days selected yet"
        },
        exceptionDays: {
            am: "Բացառության օրեր",
            ru: "Дни исключения",
            en: "Exception Days"
        },
        exceptionDaysDescription: {
            am: "Խնդրում ենք նշել այն օրերը, երբ դուք չեք կարող աշխատել կամ նախատեսում եք աշխատել հավելյալ ժամեր։",
            ru: "Пожалуйста, укажите дни, когда вы не можете работать или планируете работать дополнительные часы.",
            en: "Please indicate the days when you cannot work or plan to work additional hours."
        },
        currentExceptionDays: {
            am: "Ընթացիկ բացառության օրեր",
            ru: "Текущие дни исключения",
            en: "Current Exception Days"
        },
        noExceptionDays: {
            am: "Դեռ չկան նշված բացառության օրեր",
            ru: "Дни исключения еще не указаны",
            en: "No exception days specified yet"
        },
        addNewException: {
            am: "Ավելացնել նոր բացառություն",
            ru: "Добавить новое исключение",
            en: "Add New Exception"
        },
        selectExceptionDays: {
            am: "Ընտրեք բացառության օրերը",
            ru: "Выберите дни исключения",
            en: "Select Exception Days"
        },
        from: {
            am: "Սկսած",
            ru: "С",
            en: "From"
        },
        to: {
            am: "Մինչև",
            ru: "До",
            en: "To"
        },
        invalidTimeRange: {
            am: "Սխալ ժամանակային միջակայք: «Սկսած» ժամը պետք է լինի «Մինչև» ժամից ավելի վաղ",
            ru: "Неверный временной диапазон: время «С» должно быть раньше времени «До»",
            en: "Invalid time range: \"From\" time must be before \"To\" time"
        },
        timeValidationError: {
            am: "Խնդրում ենք ուղղել ժամանակային միջակայքի սխալները նախքան պահպանելը",
            ru: "Пожалуйста, исправьте ошибки временного диапазона перед сохранением",
            en: "Please fix the time range errors before saving"
        },
        scheduleUpdated: {
            am: "Գրաֆիկը հաջողությամբ թարմացվել է",
            ru: "Расписание успешно обновлено",
            en: "Schedule updated successfully"
        },
        updateError: {
            am: "Չհաջողվեց թարմացնել գրաֆիկը: Խնդրում ենք փորձել կրկին",
            ru: "Не удалось обновить расписание. Пожалуйста, попробуйте снова",
            en: "Failed to update schedule. Please try again"
        },
        exceptionDaysAdded: {
            am: "Բացառության օրերը հաջողությամբ ավելացվել են",
            ru: "Дни исключения успешно добавлены",
            en: "Exception days added successfully"
        },
        confirmDeleteException: {
            am: "Վստա՞հ եք, որ ցանկանում եք ջնջել բացառության օրը:",
            ru: "Вы уверены, что хотите удалить день исключения?",
            en: "Are you sure you want to delete the exception day?"
        },
        exceptionDayDeleted: {
            am: "Բացառության օրը հաջողությամբ ջնջվել է",
            ru: "День исключения успешно удален",
            en: "Exception day deleted successfully"
        },
        deleteError: {
            am: "Չհաջողվեց ջնջել բացառության օրը: Խնդրում ենք փորձել կրկին",
            ru: "Не удалось удалить день исключения. Пожалуйста, попробуйте снова",
            en: "Failed to delete exception day. Please try again"
        },
        exceptionDaysError: {
            am: "Չհաջողվեց ավելացնել բացառության օրերը: Խնդրում ենք փորձել կրկին",
            ru: "Не удалось добавить дни исключения. Пожалуйста, попробуйте снова",
            en: "Failed to add exception days. Please try again"
        },
        invalidExceptionDay: {
            am: "Անվավեր բացառության օր: Ամսաթիվը կարող է արդեն նշված լինել որպես բացառություն կամ անվավեր լինել: Խնդրում ենք ստուգել ամսաթիվը և փորձել կրկին:",
            ru: "Недействительный день исключения: Дата может быть уже указана как исключение или быть недействительной. Пожалуйста, проверьте дату и попробуйте снова.",
            en: "Invalid exception day: The date may already be set as an exception or may be invalid. Please check the date and try again."
        },
        companySchedules: {
            am: "Ընկերությունների գրաֆիկներ",
            ru: "Расписания компаний",
            en: "Company Schedules"
        },
        companySchedulesDescription: {
            am: "Սահմանեք առանձին առաքման գրաֆիկ ընկերության համար։ Առանց գրաֆիկի ընկերություններն օգտագործում են Ձեր աշխատանքային օրերը։ Բացառության օրերը գործում են բոլոր ընկերությունների համար։",
            ru: "Задайте отдельное расписание доставки для компании. Компании без расписания используют ваши рабочие дни. Дни исключения действуют для всех компаний.",
            en: "Set a separate delivery schedule for a company. Companies without one use your working days. Exception days apply to every company."
        },
        noCompanies: {
            am: "Դեռ չկան ընկերություններ",
            ru: "Компаний пока нет",
            en: "No companies yet"
        },
        usesDefaultSchedule: {
            am: "Օգտագործում է աշխատանքային օրերը",
            ru: "Использует рабочие дни",
            en: "Uses working days"
        },
        leadTimeHours: {
            am: "Նվազագույն նախապես պատվիրելու ժամանակ (ժամ)",
            ru: "Минимальное время заказа заранее (часы)",
            en: "Minimum notice (hours)"
        },
        leadTimeShort: {
            am: "Նախապես",
            ru: "Заранее",
            en: "Notice"
        },
        hoursShort: {
            am: "ժ",
            ru: "ч",
            en: "h"
        },
        modeRange: {
            am: "Միջակայք",
            ru: "Диапазон",
            en: "Range"
        },
        modeSlots: {
            am: "Ժամեր",
            ru: "Слоты",
            en: "Slots"
        },
        addSlot: {
            am: "Ավելացնել ժամ",
            ru: "Добавить время",
            en: "Add time"
        },
        slotsCount: {
            am: "ժամ",
            ru: "слот(ов)",
            en: "slot(s)"
        },
        noSlotsError: {
            am: "Ավելացրեք առնվազն մեկ ժամ",
            ru: "Добавьте хотя бы одно время",
            en: "Add at least one time"
        },
        invalidLeadTime: {
            am: "Ժամերը պետք է լինեն 0-ից 168",
            ru: "Часы должны быть от 0 до 168",
            en: "Hours must be between 0 and 168"
        },
        resetToDefault: {
            am: "Վերադարձնել աշխատանքային օրերին",
            ru: "Сбросить к рабочим дням",
            en: "Reset to working days"
        },
        companyScheduleHint: {
            am: "Չնշված օրերին ընկերությունը փակ է։ Եթե ոչ մի օր չնշեք, կօգտագործվեն Ձեր աշխատանքային օրերը։",
            ru: "В неотмеченные дни компания закрыта. Если не отметить ни одного дня, будут использоваться ваши рабочие дни.",
            en: "Unchecked days are closed for this company. If no day is checked, your working days are used."
        },
        companyScheduleLoadError: {
            am: "Չհաջողվեց բեռնել ընկերությունների գրաֆիկները",
            ru: "Не удалось загрузить расписания компаний",
            en: "Failed to load company schedules"
        }
    },

    // Menu page
    menu: {
        tag: {
            am: "Կատեգորիա",
            ru: "Категория",
            en: "Category"
        },
        configurable: {
            am: "Կարգավորվող",
            ru: "Конфигурованый",
            en: "Configurable"
        },
        formValidationError: {
            am: "Խնդրում ենք լրացնել բոլոր պարտադիր դաշտերը",
            ru: "Пожалуйста, заполните все обязательные поля",
            en: "Please fill in all required fields"
        },
        pendingDishesCannotBeEdited: {
            am: "կերակուրները սպասում է հաստատման",
            ru: "Эти блюда ожидают подтверждения",
            en: "These dishes are pending approval"
        },
        disableDish: {
            am: "Անջատել",
            ru: "Деактивировать",
            en: "Disable"
        },
        enableDish: {
            am: "Միացնել",
            ru: "Aктивировать",
            en: "Enable"
        },
        saveChanges: {
            am: "Պահպանել",
            ru: "Сохранить изменения",
            en: "Save Changes"
        },
        additions: {
            am: "Հավելումներ",
            ru: "Дополнения",
            en: "Additions"
        },
        hasAdditions: {
            am: "Հավելումներով",
            ru: "С дополнениями",
            en: "With additions"
        },
        noAdditions: {
            am: "Առանց հավելումների",
            ru: "Без дополнений",
            en: "No additions"
        },
        ungrouped: {
            am: "Չխմբավորված",
            ru: "Без группы",
            en: "Ungrouped"
        },
        addAddition: {
            am: "Ավելացնել հավելում",
            ru: "Добавить дополнение",
            en: "Add Addition"
        },
        ordering: {
            am: "Հերթականություն",
            ru: "Порядок",
            en: "Ordering"
        },
        activateSelected: {
            am: "Ակտիվացնել",
            ru: "Активировать",
            en: "Activate"
        },
        deactivateSelected: {
            am: "Ապաակտիվացնել",
            ru: "Деактивировать",
            en: "Deactivate"
        },
        activating: {
            am: "Ակտիվացվում է...",
            ru: "Активация...",
            en: "Activating..."
        },
        deactivating: {
            am: "Ապաակտիվացվում է...",
            ru: "Деактивация...",
            en: "Deactivating..."
        },
        bulkActivateSuccess: {
            am: "Ուտեստները հաջողությամբ ակտիվացվել են",
            ru: "Блюда успешно активированы",
            en: "Dishes activated successfully"
        },
        bulkDeactivateSuccess: {
            am: "Ուտեստները հաջողությամբ ապաակտիվացվել են",
            ru: "Блюда успешно деактивированы",
            en: "Dishes deactivated successfully"
        },
        bulkStatusError: {
            am: "Չհաջողվեց թարմացնել ուտեստների կարգավիճակը",
            ru: "Не удалось обновить статус блюд",
            en: "Failed to update dishes status"
        },
        confirmBulkActivate: {
            am: "Միանգամից ակտիվացնե՞լ նշված ուտեստները:",
            ru: "Активировать все выбранные блюда?",
            en: "Activate all selected dishes?"
        },
        confirmBulkDeactivate: {
            am: "Միանգամից ապաակտիվացնե՞լ նշված ուտեստները:",
            ru: "Деактивировать все выбранные блюда?",
            en: "Deactivate all selected dishes?"
        },
        export: {
            am: "Արտահանել",
            ru: "Экспорт",
            en: "Export"
        },
        exporting: {
            am: "Արտահանվում է...",
            ru: "Экспортируется...",
            en: "Exporting..."
        },
        exportSuccess: {
            am: "Մենյուն հաջողությամբ արտահանվեց",
            ru: "Меню успешно экспортировано",
            en: "Menu exported successfully"
        },
        exportError: {
            am: "Մենյուի արտահանումը ձախողվեց",
            ru: "Не удалось экспортировать меню",
            en: "Failed to export menu"
        },
        more: {
            am: "Ավելին",
            ru: "Еще",
            en: "More"
        },
        saveTagsOrder: {
            am: "Պահպանել կատեգորիաների հերթականությունը",
            ru: "Сохранить порядок категорий",
            en: "Save Categories Order"
        },
        saveDishesOrder: {
            am: "Պահպանել ուտեստների հերթականությունը",
            ru: "Сохранить порядок блюд",
            en: "Save Dishes Order"
        },
        translate: {
            am: "Թարգմանել",
            ru: "Перевести",
            en: "Translate"
        },
        translateAll: {
            am: "Թարգմանել բոլորը",
            ru: "Перевести все",
            en: "Translate All"
        },
        translating: {
            am: "Թարգմանվում է...",
            ru: "Переводится...",
            en: "Translating..."
        },
        orderingPageTitle: {
            am: "Հերթականության կարգավորում",
            ru: "Настройка порядка",
            en: "Order Configuration"
        },
        dishes: {
            am: "ուտեստներ",
            ru: "блюда",
            en: "dishes"
        },
        dish: {
            am: "ուտեստ",
            ru: "блюдo",
            en: "dish"
        },
        selectAdditions: {
            am: "Ընտրեք հավելումները",
            ru: "Выберите дополнения",
            en: "Select Additions"
        },
        addDish: {
            am: "Ավելացնել կերակուր",
            ru: "Добавить блюдо",
            en: "Add Dish"
        },
        // Import feature translations - nested under menu.import
        import: {
            am: "Ներմուծել",
            ru: "Импорт",
            en: "Import"
        },
        importTitle: {
            am: "Ներմուծել Մենյու",
            ru: "Импорт Меню",
            en: "Import Menu"
        },
        downloadTemplate: {
            am: "Ներբեռնել Ձևանմուշ",
            ru: "Скачать Шаблон",
            en: "Download Template"
        },
        selectDataFile: {
            am: "Ընտրել Տվյալների Ֆայլ",
            ru: "Выбрать Файл Данных",
            en: "Select Data File"
        },
        dataFileDescription: {
            am: "Վերբեռնեք CSV կամ Excel ֆայլ, որը պարունակում է ուտեստների տվյալներ",
            ru: "Загрузите CSV или Excel файл с данными блюд",
            en: "Upload a CSV or Excel file containing dish data"
        },
        dragDropDataFile: {
            am: "Քաշեք և գցեք ձեր տվյալների ֆայլը այստեղ",
            ru: "Перетащите файл данных сюда",
            en: "Drag and drop your data file here"
        },
        selectImageZip: {
            am: "Ընտրել Պատկերների ZIP (Ընտրովի)",
            ru: "Выбрать ZIP с Изображениями (Опционально)",
            en: "Select Image ZIP (Optional)"
        },
        imageZipDescription: {
            am: "Վերբեռնեք ZIP ֆայլ, որը պարունակում է ուտեստների պատկերներ: Պատկերները պետք է համապատասխանեն ձեր տվյալների ֆայլի ֆայլերի անուններին:",
            ru: "Загрузите ZIP файл с изображениями блюд. Имена файлов должны соответствовать именам в файле данных.",
            en: "Upload a ZIP file containing dish images. Images should match the filenames in your data file."
        },
        dragDropImageZip: {
            am: "Քաշեք և գցեք ձեր պատկերների ZIP ֆայլը այստեղ",
            ru: "Перетащите ZIP файл с изображениями сюда",
            en: "Drag and drop your image ZIP file here"
        },
        next: {
            am: "Հաջորդ",
            ru: "Далее",
            en: "Next"
        },
        parsing: {
            am: "Վերլուծվում է...",
            ru: "Парсинг...",
            en: "Parsing..."
        },
        fileParsed: {
            am: "Ֆայլը վերլուծվեց",
            ru: "Файл распарсен",
            en: "File parsed"
        },
        status: {
            am: "Կարգավիճակ",
            ru: "Статус",
            en: "Status"
        },
        name: {
            am: "Անուն",
            ru: "Название",
            en: "Name"
        },
        type: {
            am: "Տեսակ",
            ru: "Тип",
            en: "Type"
        },
        total: {
            am: "Ընդամենը",
            ru: "Всего",
            en: "Total"
        },
        valid: {
            am: "Վավեր",
            ru: "Валидные",
            en: "Valid"
        },
        invalid: {
            am: "Անվավեր",
            ru: "Невалидные",
            en: "Invalid"
        },
        selected: {
            am: "Ընտրված",
            ru: "Выбрано",
            en: "Selected"
        },
        searchPlaceholder: {
            am: "Որոնել ուտեստ (հայերեն, ռուսերեն, անգլերեն)",
            ru: "Поиск блюда (армянский, русский, английский)",
            en: "Search dishes in any language"
        },
        all: {
            am: "Բոլորը",
            ru: "Все",
            en: "All"
        },
        acceptedTypesLabel: {
            am: "Ընդունելի ֆորմատներ: {types} (մաքս {size}ՄԲ)",
            ru: "Допустимые форматы: {types} (макс {size}МБ)",
            en: "Accepted: {types} (max {size}MB)"
        },
        acceptedTypesLabelZip: {
            am: "Ընդունելի ZIP: {types} (մաքս {size}ՄԲ)",
            ru: "Допустимые ZIP: {types} (макс {size}МБ)",
            en: "Accepted: {types} (max {size}MB)"
        },
        confirmImport: {
            am: "Հաստատել Ներմուծումը",
            ru: "Подтвердить Импорт",
            en: "Confirm Import"
        },
        importing: {
            am: "Ներմուծվում են ուտեստները...",
            ru: "Импортируются блюда...",
            en: "Importing dishes..."
        },
        pleaseWait: {
            am: "Խնդրում ենք սպասել, մինչ մենք ներմուծում ենք ձեր ուտեստները",
            ru: "Пожалуйста, подождите, пока мы импортируем ваши блюда",
            en: "Please wait while we import your dishes"
        },
        importComplete: {
            am: "Ներմուծումը Ավարտված է",
            ru: "Импорт Завершен",
            en: "Import Complete"
        },
        exportErrorReport: {
            am: "Արտահանել Սխալների Հաշվետվություն",
            ru: "Экспорт Отчета об Ошибках",
            en: "Export Error Report"
        },
        cancel: {
            am: "Չեղարկել",
            ru: "Отменить",
            en: "Cancel"
        },
        importCancelled: {
            am: "Ներմուծումը չեղարկվեց",
            ru: "Импорт отменен",
            en: "Import cancelled"
        },
        success: {
            am: "Հաջող",
            ru: "Успешно",
            en: "Success"
        },
        failed: {
            am: "Ձախողված",
            ru: "Неудачно",
            en: "Failed"
        },
        templateDownloaded: {
            am: "Ձևանմուշը հաջողությամբ ներբեռնվեց",
            ru: "Шаблон успешно загружен",
            en: "Template downloaded successfully"
        },
        // Import error messages (nested under importErrors key)
        importErrorMessages: {
            nameHyRequired: {
                am: "Անունը (Հայերեն) պարտադիր է",
                ru: "Название (Армянский) обязательно",
                en: "Name (Armenian) is required"
            },
            typeRequired: {
                am: "Տեսակը պարտադիր է",
                ru: "Тип обязателен",
                en: "Type is required"
            },
            invalidType: {
                am: "Անվավեր տեսակ",
                ru: "Неверный тип",
                en: "Invalid type"
            },
            expirationDateRequired: {
                am: "Ժամկետը պարտադիր է և պետք է լինի թիվ",
                ru: "Срок годности обязателен и должен быть числом",
                en: "Expiration Date is required and must be a number"
            },
            ingredientHyRequired: {
                am: "Բաղադրիչները (Հայերեն) պարտադիր են",
                ru: "Ингредиенты (Армянский) обязательны",
                en: "Ingredients (Armenian) is required"
            },
            dishTagRequired: {
                am: "Կատեգորիան պարտադիր է",
                ru: "Категория обязательна",
                en: "Dish Category is required"
            },
            dishTagNotFound: {
                am: "Կատեգորիան չի գտնվել",
                ru: "Категория не найдена",
                en: "Dish Category not found"
            },
            cuisineRequired: {
                am: "Խոհանոցը պարտադիր է",
                ru: "Кухня обязательна",
                en: "Cuisine is required"
            },
            cuisineNotFound: {
                am: "Խոհանոցը չի գտնվել",
                ru: "Кухня не найдена",
                en: "Cuisine not found"
            },
            spiceLevelRequired: {
                am: "Կծվության մակարդակը պարտադիր է (1-4)",
                ru: "Уровень остроты обязателен (1-4)",
                en: "Spice Level is required (1-4)"
            },
            invalidSpiceLevel: {
                am: "Կծվության մակարդակը պետք է լինի 1-4 միջակայքում",
                ru: "Уровень остроты должен быть от 1 до 4",
                en: "Spice Level must be between 1 and 4"
            },
            invalidPrice: {
                am: "Գինը պետք է լինի վավեր դրական թիվ",
                ru: "Цена должна быть действительным положительным числом",
                en: "Price must be a valid positive number"
            },
            loadContextFailed: {
                am: "Վավերացման տվյալները բեռնելը ձախողվեց",
                ru: "Не удалось загрузить данные валидации",
                en: "Failed to load validation data"
            },
            parseFailed: {
                am: "Ֆայլի վերլուծումը ձախողվեց",
                ru: "Не удалось распарсить файл",
                en: "Failed to parse file"
            },
            noRowsSelected: {
                am: "Խնդրում ենք ընտրել առնվազն մեկ տող ներմուծելու համար",
                ru: "Пожалуйста, выберите хотя бы одну строку для импорта",
                en: "Please select at least one row to import"
            },
            noValidRows: {
                am: "Վավեր տողեր չեն ընտրվել: Խնդրում ենք ընտրել միայն վավեր տողեր:",
                ru: "Не выбрано валидных строк. Пожалуйста, выберите только валидные строки.",
                en: "No valid rows selected. Please select valid rows only."
            },
            importFailed: {
                am: "Ներմուծումը ձախողվեց",
                ru: "Импорт не удался",
                en: "Import failed"
            },
            templateDownloadFailed: {
                am: "Ձևանմուշի ներբեռնումը ձախողվեց",
                ru: "Не удалось загрузить шаблон",
                en: "Failed to download template"
            },
            noDataFile: {
                am: "Խնդրում ենք նախ ընտրել տվյալների ֆայլ",
                ru: "Пожалуйста, сначала выберите файл данных",
                en: "Please select a data file first"
            }
        },
        importWarningMessages: {
            invalidOrderBefore: {
                am: "Պատվերի նախօրոք պետք է լինի վավեր թիվ: Օգտագործվում է լռելյայն արժեքը: 1",
                ru: "Предзаказ должен быть действительным числом. Используется значение по умолчанию: 1",
                en: "Order Before must be a valid number. Using default value: 1"
            },
            invalidMinimumOrderCount: {
                am: "Նվազագույն պատվերի քանակը պետք է լինի առնվազն 1: Օգտագործվում է լռելյայն արժեքը: 1",
                ru: "Минимальное количество заказа должно быть не менее 1. Используется значение по умолчанию: 1",
                en: "Minimum Order Count must be at least 1. Using default value: 1"
            },
            noImage: {
                am: "Պատկեր չի տրամադրվել: Ուտեստը կստեղծվի առանց պատկերի:",
                ru: "Изображение не предоставлено. Блюдо будет создано без изображения.",
                en: "No image provided. Dish will be created without an image."
            },
            duplicateDish: {
                am: "Այս անունով ուտեստ արդեն գոյություն ունի: Այս տողը կբաց թողնվի:",
                ru: "Блюдо с таким названием уже существует. Эта строка будет пропущена.",
                en: "Dish with this name already exists. This row will be skipped."
            }
        },
        namePlaceholder: {
            am: "Օր․՝ Խորոված",
            ru: "Напр.: Шашлык",
            en: "Ex: Barbecue"
        },
        selectType: {
            am: "Ընտրեք տեսակը",
            ru: "Выберите тип",
            en: "Select type"
        },
        confirmDelete: {
            am: "Վստա՞հ եք, որ ցանկանում եք ջնջել այս կերակուրը:",
            ru: "Вы уверены, что хотите удалить это блюдо?",
            en: "Are you sure you want to delete this dish?"
        },
        confirmDisable: {
            am: "Վստա՞հ եք, որ ցանկանում եք անջատել այս կերակուրը:",
            ru: "Вы уверены, что хотите отключить это блюдо?",
            en: "Are you sure you want to disable this dish?"
        },
        selectionMode: {
            am: "Ընտրել",
            ru: "Выбрать",
            en: "Select"
        },
        selectAll: {
            am: "Ընտրել բոլորը",
            ru: "Выбрать все",
            en: "Select All"
        },
        deselectAll: {
            am: "Հանել բոլոր ընտրվածները",
            ru: "Снять все выделения",
            en: "Deselect All"
        },
        itemsSelected: {
            am: "{count} ընտրված",
            ru: "{count} выбрано",
            en: "{count} selected"
        },
        deleteSelected: {
            am: "Ջնջել",
            ru: "Удалить",
            en: "Delete"
        },
        confirmBulkDelete: {
            am: "Միանգամից ջնջե՞լ ընտրված ուտեստները:",
            ru: "Удалить все выбранные блюда?",
            en: "Delete all selected dishes?"
        },
        deleting: {
            am: "Ջնջվում է...",
            ru: "Удаление...",
            en: "Deleting..."
        },
        pendingApproval: {
            am: "Սպասում է հաստատման",
            ru: "Ожидает подтверждения",
            en: "Pending approval"
        },
        dishDisabledSuccess: {
            am: "Կերակուրը հաջողությամբ անջատված է",
            ru: "Блюдо успешно отключено",
            en: "Dish successfully disabled"
        },
        dishDisabledError: {
            am: "Չհաջողվեց անջատել կերակուրը",
            ru: "Не удалось отключить блюдо",
            en: "Failed to disable dish"
        },
        systemData: {
            am: "Համակարգային տվյալներ",
            ru: "Системные данные",
            en: "System Data"
        },
        portion: {
            am: "Չափաբաժին",
            ru: "Порция",
            en: "Portion"
        },
        portionArmenian: {
            am: "Չափաբաժին (Հայերեն)",
            ru: "Порция (Армянский)",
            en: "Portion (Armenian)"
        },
        portionRussian: {
            am: "Չափաբաժին (Ռուսերեն)",
            ru: "Порция (Русский)",
            en: "Portion (Russian)"
        },
        portionEnglish: {
            am: "Չափաբաժին (Անգլերեն)",
            ru: "Порция (Английский)",
            en: "Portion (English)"
        },
        portionPlaceholder: {
            am: "Օր․՝ 1 անձի համար/1 հատ/1 բաժին",
            ru: "Напр.: на 1 персону",
            en: "Ex: for 1 person"
        },
        expirationDays: {
            am: "Պահպանման օրերի քանակ",
            ru: "Количество дней хранения",
            en: "Expiration Days"
        },
        preOrder: {
            am: "Նախապատվեր",
            ru: "Предварительный заказ",
            en: "Preorder"
        },
        sameDayOrder: {
            am: "Միշտ հասանելի է պատվերի համար",
            ru: "Всегда доступно для заказа",
            en: "Always available for order"
        },
        expirationDaysPlaceholder: {
            am: "Օր․՝ 3",
            ru: "Напр.: 3",
            en: "Ex: 3"
        },
        preOrderDays: {
            am: "Պատվերի տրման մինիմալ օրերի քանակը",
            ru: "День предварительного заказа",
            en: "Pre-order Day"
        },
        preOrderDaysHint: {
            am: "Եթե միշտ հասանելի է, նշեք 0",
            ru: "Если всегда доступно, укажите 0",
            en: "If always available, specify 0"
        },
        preOrderDaysPlaceholder: {
            am: "Օր․՝ 1",
            ru: "Напр.: 1",
            en: "Ex: 1"
        },
        daysInAdvance: {
            am: "օր առաջ",
            ru: "дней вперед",
            en: "days in advance"
        },
        spiceLevel: {
            am: "Կծվության աստիճան",
            ru: "Уровень остроты",
            en: "Spice Level"
        },
        selectSpiceLevel: {
            am: "Ընտրեք կծվության աստիճանը",
            ru: "Выберите уровень остроты",
            en: "Select spice level"
        },
        ingredients: {
            am: "Բաղադրություն",
            ru: "Состав",
            en: "Ingredients"
        },
        ingredientsAndTags: {
            am: "Բաղադրություն և կատեգորիաներ",
            ru: "Состав и категории",
            en: "Ingredients and Categories"
        },
        ingredientsArmenian: {
            am: "Բաղադրություն (Հայերեն)",
            ru: "Состав (Армянский)",
            en: "Ingredients (Armenian)"
        },
        ingredientsRussian: {
            am: "Բաղադրություն (Ռուսերեն)",
            ru: "Состав (Русский)",
            en: "Ingredients (Russian)"
        },
        ingredientsEnglish: {
            am: "Բաղադրություն (Անգլերեն)",
            ru: "Состав (Английский)",
            en: "Ingredients (English)"
        },
        ingredientsPlaceholder: {
            am: "Նշեք բաղադրությունը մանրամասն",
            ru: "Укажите состав подробно",
            en: "Specify ingredients in detail"
        },
        ingredientsExamplePlaceholder: {
            am: "Օր․՝ Տավարի միս, սոխ, համեմունքներ...",
            ru: "Напр.: Говядина, лук, специи...",
            en: "Ex: Beef, onion, spices..."
        },
        cuisineTag: {
            am: "Խոհանոցային կատեգորիա",
            ru: "Кулинарная категория",
            en: "Cuisine Category"
        },
        selectCuisineTag: {
            am: "Ընտրեք խոհանոցային կատեգորիան",
            ru: "Выберите кулинарную категорию",
            en: "Select cuisine category"
        },
        tags: {
            am: "Կատեգորիաներ",
            ru: "Категории",
            en: "Categories"
        },
        dishTags: {
            am: "Կատեգորիա",
            ru: "Категория",
            en: "Category"
        },
        selectTag: {
            am: "Ընտրեք կատեգորիան",
            ru: "Выберите категорию",
            en: "Select category"
        },
        selectTags: {
            am: "Ընտրեք կատեգորիաները",
            ru: "Выберите категории",
            en: "Select categories"
        },
        dietaryOptions: {
            am: "Սննդակարգի տեսակներ",
            ru: "Типы диеты",
            en: "Dietary Options"
        },
        selectDietaryOptions: {
            am: "Սննդակարգի տեսակները",
            ru: "Выберите типы диеты",
            en: "Select dietary options"
        },
        possibleSpiceLevels: {
            am: "Հնարավոր կծվություն",
            ru: "Возможные уровни остроты",
            en: "Possible Spice Levels"
        },
        selectPossibleSpiceLevels: {
            am: "հնարավոր տարբերակները",
            ru: "Bозможные варианты",
            en: "All possible options"
        },
        notSpicyNoPossibleLevels: {
            am: "Ոչ կծու ուտեստների համար չի կիրառվում",
            ru: "Не применимо для неострых блюд",
            en: "Not applicable for non-spicy dishes"
        },
        perPage: {
            am: "Էջում",
            ru: "На странице",
            en: "Per page"
        },
        gridView: {
            am: "Ցանցային տեսք",
            ru: "Сетка",
            en: "Grid view"
        },
        listView: {
            am: "Ցուցակի տեսք",
            ru: "Список",
            en: "List view"
        },
        showLabel: {
            am: "Ցուցադրել",
            ru: "Показать",
            en: "Show"
        },
        filterAllDishes: {
            am: "Բոլորը",
            ru: "Все",
            en: "All"
        },
        filterActiveOnly: {
            am: "Ակտիվ",
            ru: "Активные",
            en: "Active"
        },
        noDishes: {
            am: "Դուք չունեք ստեղծված կերակուրներ",
            ru: "У вас нет созданных блюд",
            en: "You don't have any dishes created"
        },
        noSearchResults: {
            am: "Ուտեստներ չեն գտնվել",
            ru: "Блюда не найдены",
            en: "No dishes found"
        },
        generalInfo: {
            am: "Ընդհանուր տեղեկություններ",
            ru: "Общая информация",
            en: "General Information"
        },
        nameArmenian: {
            am: "Անվանում (Հայերեն)",
            ru: "Название (Армянский)",
            en: "Name (Armenian)"
        },
        nameRussian: {
            am: "Անվանում (Ռուսերեն)",
            ru: "Название (Русский)",
            en: "Name (Russian)"
        },
        nameEnglish: {
            am: "Անվանում (Անգլերեն)",
            ru: "Название (Английский)",
            en: "Name (English)"
        },
        price: {
            am: "Գին",
            ru: "Цена",
            en: "Price"
        },
        priceAMD: {
            am: "Գին AMD",
            ru: "Цена AMD",
            en: "Price AMD"
        },
        pricePlaceholder: {
            am: "Օր․՝ 2500",
            ru: "Напр.: 2500",
            en: "Ex: 2500"
        },
        dishType: {
            am: "Տեսակ",
            ru: "Тип",
            en: "Type"
        },
        image: {
            am: "Նկար",
            ru: "Изображение",
            en: "Image"
        },
        imageTips: {
            am: "Խորհուրդներ նկարի համար:",
            ru: "Советы по изображению:",
            en: "Image tips:"
        },
        imageHighQuality: {
            am: "Օգտագործեք բարձր որակի նկարներ",
            ru: "Используйте изображения высокого качества",
            en: "Use high quality images"
        },
        imageGoodLighting: {
            am: "Լուսավորությունը պետք է լինի լավ",
            ru: "Освещение должно быть хорошим",
            en: "Lighting should be good"
        },
        imageCentered: {
            am: "Կերակուրը պետք է լինի նկարի կենտրոնում",
            ru: "Блюдо должно быть в центре изображения",
            en: "The dish should be centered in the image"
        },
        imageAvoidDark: {
            am: "Խուսափեք մուգ կամ աղոտ նկարներից",
            ru: "Избегайте темных или размытых изображений",
            en: "Avoid dark or blurry images"
        },
        moderationNotice: {
            am: "(Ավելացելուց հետո կերակուրը պետք է հաստատվի մոդերատորների կողմից)",
            ru: "(После добавления блюдо должно быть одобрено модераторами)",
            en: "(After adding, the dish must be approved by moderators)"
        },
        pendingEditNotice: {
            am: "'Սպասում է' Կարգավիճակով կերակուրը հնարավոր չէ խմբագրել",
            ru: "Невозможно редактировать блюдо со статусом 'Ожидает'",
            en: "Cannot edit dish with 'Pending' status"
        },
        configuration: {
            am: "Կարգավորումներ",
            ru: "Конфигурации",
            en: "Configurations"
        },
        // New keys for configuration flow
        selectConfigGroup: {
            am: "Ընտրեք հավելումների խումբը",
            ru: "Выберите группу добавок",
            en: "Select an addition group"
        },
        addGroupDescription: {
            am: "Սկզբում ընտրեք հավելումների խումբը, որը ցանկանում եք ավելացնել այս ուտեստին",
            ru: "Сначала выберите группу добавок, которую вы хотите добавить к этому блюду",
            en: "Choose an additions group you want to add to this dish"
        },
        configureGroupAdditions: {
            am: "Կարգավորեք հավելումները",
            ru: "Настройте добавки",
            en: "Configure additions"
        },
        configureAdditionsDescription: {
            am: "Ընտրեք ցանկալի հավելումները և ըստ ցանկության փոխեք գները",
            ru: "Выберите нужные добавки и при необходимости измените цены",
            en: "Select desired additions and optionally change their prices"
        },
        configurationOverview: {
            am: "Կարգավորումների ակնարկ",
            ru: "Обзор конфигурации",
            en: "Configuration overview"
        },
        configurationOverviewDescription: {
            am: "Ձեր ուտեստի կարգավորումների ամփոփ տեսք",
            ru: "Сводка конфигурации вашего блюда",
            en: "Summary of your dish configurations"
        },
        selectGroup: {
            am: "Ընտրեք խումբը",
            ru: "Выберите группу",
            en: "Select a group"
        },
        addConfigurationGroup: {
            am: "Ավելացնել կարգավորման խումբ",
            ru: "Добавить группу конфигурации",
            en: "Add configuration group"
        },
        selectAdditionsFromGroup: {
            am: "Ընտրեք հավելումները այս խմբից.",
            ru: "Выберите добавки из этой группы:",
            en: "Select additions from this group:"
        },
        optionallyOverridePrices: {
            am: "Ըստ ցանկության գերակայեք գները.",
            ru: "При желании переопределите цены:",
            en: "Optionally override prices:"
        },
        basePrice: {
            am: "Հիմնական գին",
            ru: "Базовая цена",
            en: "Base price"
        },
        override: {
            am: "Գերակայում",
            ru: "Переопределено",
            en: "Override"
        },
        overridePrice: {
            am: "Գերակայել գինը",
            ru: "Переопределить цену",
            en: "Override Price"
        },
        configurationSummary: {
            am: "Կարգավորումների ամփոփում",
            ru: "Сводка конфигурации",
            en: "Configuration Summary"
        },
        selectOneAddition: {
            am: "Ընտրեք մեկ հավելում",
            ru: "Выберите одну добавку",
            en: "Select one addition"
        },
        addNewAddition: {
            am: "Նոր հավելում",
            ru: "Новая добавка",
            en: "Add New Addition"
        },
        createNewAddition: {
            am: "Ստեղծել նոր հավելում",
            ru: "Создать новую добавку",
            en: "Create New Addition"
        },
        changePrice: {
            am: "Գինը",
            ru: "Цена",
            en: "Price"
        },
        changePrices: {
            am: "Փոխել գները",
            ru: "Изменить цены",
            en: "Change prices"
        },
        additionCreatedSuccess: {
            am: "Հավելումը հաջողությամբ ստեղծվել է",
            ru: "Добавка успешно создана",
            en: "Addition created successfully"
        },
        additionCreationFailed: {
            am: "Չհաջողվեց ստեղծել հավելումը",
            ru: "Не удалось создать добавку",
            en: "Failed to create addition"
        },
        priceOverrides: {
            am: "Գների փոփոխություններ",
            ru: "Изменения цен",
            en: "Price Overrides"
        },
        dishUpdatedSuccess: {
            am: "Կերակուրը հաջողությամբ թարմացվել է",
            ru: "Блюдо успешно обновлено",
            en: "Dish successfully updated"
        },
        spiceSettings: {
            am: "Կծվության աստիճաններ",
            ru: "Уровни остроты",
            en: "Spice levels"
        },
        dishCreatedSuccess: {
            am: "Կերակուրը հաջողությամբ ստեղծվել է",
            ru: "Блюдо успешно создано",
            en: "Dish successfully created"
        },
        minimumOrderCount: {
            am: "Նվազագույն պատվերի քանակ",
            ru: "Минимальное количество заказа",
            en: "Minimum order count"
        },
        adultsOnly: {
            am: "Միայն չափահասների համար (18+)",
            ru: "Только для взрослых (18+)",
            en: "Adults Only (18+)"
        },
        priceFromGroup: {
            am: "Գինը կկազմվի «{groupName}» խմբից",
            ru: "Цена будет взята из группы «{groupName}»",
            en: "Price will be taken from {groupName} group"
        },
        additionAddedSuccess: {
            am: "Հավելումը հաջողությամբ ավելացվել է",
            ru: "Добавка успешно добавлена",
            en: "Addition added successfully"
        },
        required: {
            am: "Պարտադիր",
            ru: "Обязательно",
            en: "Required"
        },
        multiSelect: {
            am: "Բազմակի ընտրություն",
            ru: "Множественный выбор",
            en: "Multi-select"
        },
        singleSelect: {
            am: "Միայնակ ընտրություն",
            ru: "Одиночный выбор",
            en: "Single-select"
        },
        clickToUploadImage: {
            am: "Սեղմեք նկար բեռնելու համար",
            ru: "Нажмите, чтобы загрузить изображение",
            en: "Click to upload an image"
        },
        imageConversionError: {
            am: "Ֆայլի ստեղծման ընթացքում խնդիր տեղի ունեցավ: Խնդրում ենք փորձել կրկին մի քիչ հետո, կամ դիմել աջակցության բաժին, եթե խնդիրը շարունակվում է",
            ru: "Произошла ошибка при создании файла. Пожалуйста, попробуйте еще раз немного позже или обратитесь в службу поддержки, если проблема сохраняется",
            en: "An error occurred while creating the file. Please try again a bit later, or contact support if the problem persists"
        },
        imageLoadError: {
            am: "Ֆայլի բեռնման ընթացքում խնդիր տեղի ունեցավ: Խնդրում ենք փորձել կրկին մի քիչ հետո, կամ դիմել աջակցության բաժին, եթե խնդիրը շարունակվում է",
            ru: "Произошла ошибка при загрузке файла. Пожалуйста, попробуйте еще раз немного позже или обратитесь в службу поддержки, если проблема сохраняется",
            en: "An error occurred while loading the file. Please try again a bit later, or contact support if the problem persists"
        },
        fileType: {
            am: "Ֆայլի տիպ: JPG, PNG, JPEG, WEBP",
            ru: "Тип файла: JPG, PNG, JPEG, WEBP",
            en: "File type: JPG, PNG, JPEG, WEBP"
        },
        clickToView: {
            am: "Սեղմեք դիտելու համար",
            ru: "Нажмите, чтобы просмотреть",
            en: "Click to view"
        },
        changeImage: {
            am: "Փոխել նկարը",
            ru: "Изменить изображение",
            en: "Change image"
        },
        invalidFileType: {
            am: "Անվավեր ֆայլի տիպ: Խնդրում ենք ընտրել պատկերի ֆայլ (JPG, PNG, JPEG, WEBP, HEIC, HEIF):",
            ru: "Неверный тип файла. Пожалуйста, выберите файл изображения (JPG, PNG, JPEG, WEBP, HEIC, HEIF):",
            en: "Invalid file type. Please provide an image file (JPG, PNG, JPEG, WEBP, HEIC, HEIF)."
        },
        invalidFileTypeWithExtension: {
            am: "Անվավեր ֆայլի տիպ ({extension}): Խնդրում ենք ընտրել պատկերի ֆայլ (JPG, PNG, JPEG, WEBP, HEIC, HEIF):",
            ru: "Неверный тип файла ({extension}). Пожалуйста, выберите файл изображения (JPG, PNG, JPEG, WEBP, HEIC, HEIF):",
            en: "Invalid file type ({extension}). Please provide an image file (JPG, PNG, JPEG, WEBP, HEIC, HEIF)."
        },
        noOptions: {
            am: "Տարբերակներ չկան",
            ru: "Нет доступных вариантов",
            en: "No options available"
        },
        noTags: {
            am: "Մենյուի կատեգորիաներ չեն գտնվել",
            ru: "Категории меню не найдены",
            en: "No menu categories found"
        },
        noTagsDescription: {
            am: "Սկզբում ստեղծեք որոշ մենյուի կատեգորիաներ՝ ձեր կերակուրները կազմակերպելու համար:",
            ru: "Сначала создайте несколько категорий меню для организации ваших блюд.",
            en: "Create some menu categories first to organize your dishes."
        },
        selectSpiceLevelFirst: {
            am: "Խնդրում ենք նախ ընտրել կծվության աստիճանը",
            ru: "Пожалуйста, сначала выберите уровень остроты",
            en: "Please select a spice level first"
        }
    },

    // Dish types
    dishTypes: {
        BREAKFAST: {
            am: "Նախաճաշ",
            ru: "Завтрак",
            en: "Breakfast"
        },
        LUNCH: {
            am: "Ճաշ",
            ru: "Обед",
            en: "Lunch"
        },
        DINNER: {
            am: "Ընթրիք",
            ru: "Ужин",
            en: "Dinner"
        },
        SIDE: {
            am: "Գարնիր",
            ru: "Гарнир",
            en: "Side"
        },
        APPETIZER: {
            am: "Նախուտեստ",
            ru: "Закуска",
            en: "Appetizer"
        },
        DESSERT: {
            am: "Աղանդեր",
            ru: "Десерт",
            en: "Dessert"
        },
        SEMIFINISHED: {
            am: "Կիսաֆաբրիկատ",
            ru: "Полуфабрикат",
            en: "Semifinished"
        }
    },

    // Dish statuses
    dishStatuses: {
        pending: {
            am: "Սպասում է",
            ru: "Ожидание",
            en: "Pending"
        },
        active: {
            am: "Ակտիվ",
            ru: "Активный",
            en: "Active"
        },
        disabled: {
            am: "Անջատված",
            ru: "Отключен",
            en: "Disabled"
        },
        rejected: {
            am: "Մերժված",
            ru: "Отклонен",
            en: "Rejected"
        }
    },

    // Dietary options
    dietaryOptions: {
        "vegetarian": {
            am: "Բուսական",
            ru: "Вегетарианский",
            en: "Vegetarian"
        },
        "vegan": {
            am: "Վեգան",
            ru: "Веганский",
            en: "Vegan"
        },
        "gluten-free": {
            am: "Առանց գլյուտեն",
            ru: "Без глютена",
            en: "Gluten Free"
        },
        "dairy-free": {
            am: "Առանց կաթնամթերք",
            ru: "Без молочных продуктов",
            en: "Dairy Free"
        },
        "nut-free": {
            am: "Առանց ընկույզ",
            ru: "Без орехов",
            en: "Nut Free"
        },
        "halal": {
            am: "Հալալ",
            ru: "Халяль",
            en: "Halal"
        },
        "kosher": {
            am: "Կոշեր",
            ru: "Кошерный",
            en: "Kosher"
        },
        "paleo": {
            am: "Պալեո",
            ru: "Палео",
            en: "Paleo"
        },
        "low-fodmap": {
            am: "Ցածր FODMAP",
            ru: "Низкий FODMAP",
            en: "Low FODMAP"
        },
        "whole-30": {
            am: "Whole 30",
            ru: "Whole 30 диета",
            en: "Whole 30"
        },
        "no-dietary-restrictions": {
            am: "Առանց հատուկ սահմանափակումների",
            ru: "Без особых ограничений",
            en: "No special dietary restrictions"
        }
    },

    validation: {
        fixErrors: {
            am: "Խնդրում ենք ուղղել սխալները",
            ru: "Пожалуйста, исправьте ошибки",
            en: "Please fix the errors"
        },
        invalidEmail: {
            am: "Սխալ էլ. փոստի հասցե",
            ru: "Неверный адрес электронной почты",
            en: "Invalid email address"
        },
        percentageValue: {
            am: "Միայն 0-100 թվեր",
            ru: "Только числа от 0 до 100",
            en: "Only numbers from 0 to 100"
        },
        negativeValue: {
            am: "Արժեքը չի կարող բացասական լինել",
            ru: "Значение не может быть отрицательным",
            en: "Value cannot be negative"
        },
        invalidPhoneNumber: {
            am: "Հեռախոսի համարը պետք է սկսվի +374 ով",
            ru: "Номер телефона должен начинаться с +374",
            en: "Phone number must start with +374"
        },
        phoneNumberLength: {
            am: "Հեռախոսահամարը պետք է լինի 8 նիշ",
            ru: "Номер телефона должен содержать 8 цифр",
            en: "Phone number must be 8 digits"
        },
        phoneNumberInvalid: {
            am: "Հեռախոսահամարը պետք է պարունակի միայն թվեր",
            ru: "Номер телефона должен содержать только цифры",
            en: "Phone number must contain only digits"
        },
        nameRequired: {
            am: "Պարտադիր դաշտ",
            ru: "Обязательное поле",
            en: "Required field"
        },
        priceRequired: {
            am: "Գինը պարտադիր է",
            ru: "Цена обязательна",
            en: "Price is required"
        },
        typeRequired: {
            am: "Տեսակը պարտադիր է",
            ru: "Тип обязателен",
            en: "Type is required"
        },
        expirationRequired: {
            am: "Պահպանման օրերը պարտադիր են",
            ru: "Количество дней хранения обязательно",
            en: "Expiration days is required"
        },
        orderBeforeRequired: {
            am: "Նախնական պատվերի օրը պարտադիր է",
            ru: "День предварительного заказа обязателен",
            en: "Pre-order day is required"
        },
        portionRequired: {
            am: "Չափաբաժինը պարտադիր է",
            ru: "Порция обязательна",
            en: "Portion is required"
        },
        ingredientRequired: {
            am: "Բաղադրությունը պարտադիր է",
            ru: "Состав обязателен",
            en: "Ingredients are required"
        },
        cuisineTagRequired: {
            am: "Խոհանոցային կատեգորիան պարտադիր է",
            ru: "Кулинарная категория обязательна",
            en: "Cuisine category is required"
        },
        dishTagDtos: {
            am: "Կերակրի կատեգորիան պարտադիր է",
            ru: "Категория блюда обязательна",
            en: "Dish category is required"
        },
        endDateAfterStartDate: {
            am: "Ավարտի ամսաթիվը պետք է լինի սկզբի ամսաթվից հետո",
            ru: "Дата окончания должна быть после даты начала",
            en: "End date must be after start date"
        },
        dishTagDto: {
            am: "Կերակրի կատեգորիան պարտադիր է",
            ru: "Категория блюда обязательна",
            en: "Dish category is required"
        },
        spiceLevelRequired: {
            am: "Կծվության աստիճանը պարտադիր է",
            ru: "Уровень остроты обязателен",
            en: "Spice level is required"
        },
        required: {
            am: "Պարտադիր դաշտ",
            ru: "Обязательное поле",
            en: "Required field"
        },
        expirationDaysRequired: {
            am: "Պահպանման օրերի քանակը պարտադիր է",
            ru: "Количество дней хранения обязательно",
            en: "Expiration days is required"
        },
        ingredientsRequired: {
            am: "Բաղադրությունը պարտադիր է",
            ru: "Состав обязателен",
            en: "Ingredients are required"
        },
        imageRequired: {
            am: "Նկարը պարտադիր է",
            ru: "Изображение обязательно",
            en: "Image is required"
        }
    },

    promocodes: {
        title: {
            am: "Պրոմոկոդեր",
            ru: "Промокоды",
            en: "Promocodes"
        },
        minOrderAmount: {
            am: "Նվազագույն պատվերի գումար",
            ru: "Минимальная сумма заказа",
            en: "Minimum Order Amount"
        },
        upperLimitValue: {
            am: "Վերին սահմանաչափ",
            ru: "Верхний лимит",
            en: "Upper Limit Value"
        },
        addPromocode: {
            am: "Ավելացնել Պրոմոկոդ",
            ru: "Добавить промокод",
            en: "Add Promocode"
        },
        maxUsage: {
            am: "Առավելագույն օգտագործման քանակ",
            ru: "Максимальное использование",
            en: "Max Usage Count"
        },
        maxUsagePerUser: {
            am: "Առավելագույն օգտագործման քանակ ամեն օգտատիրոջ համար ",
            ru: "Максимальное использование на пользователя",
            en: "Max Usage Count Per User"
        },
        promocode: {
            am: "Պրոմոկոդ",
            ru: "Промокод",
            en: "Promocode"
        },
        code: {
            am: "Պրոմո կոդ",
            ru: "Код уведомления",
            en: "Code"
        },
        usageLimitToggle: {
            am: "Քանակի Սահմանափակում",
            ru: "Лимит Использования",
            en: "Usage Limit"
        },
        promocodeCode: {
            am: "Պրոմոկոդի կոդ",
            ru: "Идентификатор уведомления",
            en: "Promocode Code"
        },
        type: {
            am: "Զեղչի տեսակ",
            ru: "Тип промокода",
            en: "Discount Type"
        },
        typesDescription: {
            percentage: {
                am: "Պատվերի գնից նշված % ի չափով զեղչ",
                ru: "Скидка от цены заказа в размере указанного %",
                en: "Discount of specified % off order price"
            },
            fixed: {
                am: "Պատվերի գնից նշված գումարի չափով զեղչ",
                ru: "Скидка от цены заказа в размере указанной суммы",
                en: "Discount of specified amount off order price"
            },
            delivery: {
                am: "Պատվերի առաքման գնից նշված % ի չափով զեղչ",
                ru: "Скидка от стоимости доставки заказа в размере указанного %",
                en: "Discount of specified % off order delivery price"
            }
        },
        status: {
            am: "Կարգավիճակ",
            ru: "Статус",
            en: "Status"
        },
        startDate: {
            am: "Սկիզբ",
            ru: "Начало",
            en: "Start"
        },
        endDate: {
            am: "Ավարտ",
            ru: "Конец",
            en: "End"
        },
        discountType: {
            am: "Պրոմո տեսակ",
            ru: "Тип скидки",
            en: "Discount Type"
        },
        discountValue: {
            am: "Պրոմո արժեք",
            ru: "Значение скидки",
            en: "Discount Value"
        },
        validFrom: {
            am: "Սկիզբ ամսաթիվ",
            ru: "Дата начала",
            en: "Valid From"
        },
        validTo: {
            am: "Ավարտ ամսաթիվ",
            ru: "Дата окончания",
            en: "Valid To"
        },
        minimumOrderAmount: {
            am: "Պատվերի նվազագույն գումարը",
            ru: "Минимальная сумма заказа",
            en: "Minimum Order Amount"
        },
        maxUses: {
            am: "Առավելագույն օգտագործում",
            ru: "Максимальное использование",
            en: "Max Uses"
        },
        maxUsesPerUser: {
            am: "Առավելագույն օգտագործում ըստ օգտատիրոջ",
            ru: "Максимальное использование на пользователя",
            en: "Max Uses Per User"
        },
        allowedPaymentTypes: {
            am: "Թույլատրելի վճարման մեթոդներ",
            ru: "Разрешенные способы оплаты",
            en: "Allowed Payment Methods"
        },
        enableCustomerLimit: {
            am: "Առավելագույն օգտագործումներ",
            ru: "Включить ограничение клиентов",
            en: "Enable Customer Limit"
        },
        userType: {
            am: "Օգտատեր",
            ru: "Пользователь",
            en: "User"
        },
        userTypePlaceholder: {
            am: "+37455112233 (օրինակ)",
            ru: "+37455112233 (example)",
            en: "+37455112233 (example)"
        },
        enablePaymentLimit: {
            am: "Վճարման մեթոդ",
            ru: "Սпособа оплаты",
            en: "Payment Method"
        },
        createPromocode: {
            am: "Ստեղծել պրոմոկոդ",
            ru: "Создать промокод",
            en: "Create Promocode"
        },
        editPromocode: {
            am: "Փոփոխել պրոմոկոդը",
            ru: "Изменить промокод",
            en: "Edit Promocode"
        },
        viewPromocode: {
            am: "Դիտել պրոմոկոդը",
            ru: "Просмотреть промокод",
            en: "View Promocode"
        },
        deletedSuccess: {
            am: "Պրոմոկոդը հաջողությամբ ջնջվեց",
            ru: "Промокод успешно удален",
            en: "Promocode deleted successfully"
        },
        types: {
            FIXED: {
                am: "Ֆիքսված գին",
                ru: "Фиксированная цена",
                en: "Fixed Price"
            },
            PERCENTAGE: {
                am: "Տոկոսային գին",
                ru: "Процентная скидка",
                en: "Percentage"
            },
            DELIVERY_PERCENTAGE: {
                am: "Առաքում",
                ru: "Доставка",
                en: "Delivery"
            }
        },
        paymentMethods: {
            any: {
                am: "Ցանկացած տիպի",
                ru: "Любой тип",
                en: "Any type"
            },
            cashless: {
                am: "Միայն Անկանխիկ",
                ru: "Только безналичный",
                en: "Cashless only"
            },
            cash: {
                am: "Միայն կանխիկ",
                ru: "Только наличные",
                en: "Cash only"
            }
        },
        customerLimitDescription: {
            am: "Սահմանափակում է, թե քանի անգամ կարող է օգտագործվել այս պրոմոկոդը",
            ru: "Ограничивает, сколько раз может быть использован этот промокод",
            en: "Limits how many times this promocode can be used"
        },
        paymentLimitDescription: {
            am: "Ընտրեք, թե որ վճարման մեթոդների հետ կարող է օգտագործվել այս պրոմոկոդը",
            ru: "Выберите, с какими способами оплаты может использоваться этот промокод",
            en: "Select which payment methods this promocode can be used with"
        }
    },
    clients: {
        title: {
            am: "Հաճախորդներ",
            ru: "Клиенты",
            en: "Clients"
        },
        companies: {
            am: "Ընկերություններ",
            ru: "Компании",
            en: "Companies"
        },
        company: {
            am: "Ընկերություն",
            ru: "Компания",
            en: "Company"
        },
        companyName: {
            am: "Ընկերության անվանումը",
            ru: "Название компании",
            en: "Company Name"
        },
        addCompany: {
            am: "Ավելացնել ընկերություն",
            ru: "Добавить компанию",
            en: "Add Company"
        },
        editCompany: {
            am: "Խմբագրել ընկերությունը",
            ru: "Редактировать компанию",
            en: "Edit Company"
        },
        manageCompanies: {
            am: "Կառավարել ընկերությունները",
            ru: "Управление компаниями",
            en: "Manage Companies"
        },
        noCompanies: {
            am: "Ընկերություններ չեն գտնվել",
            ru: "Компании не найдены",
            en: "No companies found"
        },
        latitude: {
            am: "Լայնություն",
            ru: "Широта",
            en: "Latitude"
        },
        longitude: {
            am: "Երկայնություն",
            ru: "Долгота",
            en: "Longitude"
        },
        latShort: {
            am: "լայն",
            ru: "шир",
            en: "lat"
        },
        longShort: {
            am: "երկ",
            ru: "долг",
            en: "long"
        },
        invalidCoordinates: {
            am: "Կոորդինատները սխալ են",
            ru: "Некорректные координаты",
            en: "Invalid coordinates"
        },
        clientInfo: {
            am: "Հաճախորդի մասին",
            ru: "О клиенте",
            en: "Client Details"
        },
        clientOrders: {
            am: "Պատվերների պատմություն",
            ru: "История заказов",
            en: "Order History"
        },
        phoneNumber: {
            am: "Հեռախոսահամար",
            ru: "Номер телефона",
            en: "Phone Number"
        },
        email: {
            am: "Էլ. փոստ",
            ru: "Электронная почта",
            en: "Email"
        },
        name: {
            am: "Անուն",
            ru: "Имя",
            en: "Name"
        },
        noClients: {
            am: "Հաճախորդներ չեն գտնվել",
            ru: "Клиенты не найдены",
            en: "No clients found"
        },
        noOrders: {
            am: "Այս հաճախորդի համար պատվերներ չկան",
            ru: "У этого клиента нет заказов",
            en: "This client has no orders"
        },
        fetchError: {
            am: "Հնարավոր չեղավ բեռնել հաճախորդներին",
            ru: "Не удалось загрузить клиентов",
            en: "Failed to load clients"
        },
        fetchTelegramError: {
            am: "Հնարավոր չեղավ բեռնել Telegram հաճախորդների տվյալները",
            ru: "Не удалось загрузить данные клиентов Telegram",
            en: "Failed to load Telegram client data"
        },
        fetchOrdersError: {
            am: "Հնարավոր չեղավ բեռնել պատվերները",
            ru: "Не удалось загрузить заказы",
            en: "Failed to load orders"
        },
        searchPlaceholder: {
            am: "Որոնել հեռախոսահամարով կամ էլ. փոստով",
            ru: "Поиск по телефону или email",
            en: "Search by phone or email"
        },
        showing: {
            am: "Ցուցադրվում է",
            ru: "Показано",
            en: "Showing"
        },
        of: {
            am: "ից",
            ru: "из",
            en: "of"
        },
        clients: {
            am: "հաճախորդ",
            ru: "клиентов",
            en: "clients"
        },
        totalOrders: {
            am: "Ընդհանուր պատվեր",
            ru: "Всего заказов",
            en: "Total Orders"
        },
        totalSpent: {
            am: "Ընդհանուր գումար",
            ru: "Общая сумма",
            en: "Total Revenue"
        },
        avgOrderValue: {
            am: "Միջին պատվեր",
            ru: "Средний чек",
            en: "Average Order"
        },
        delivered: {
            am: "Առաքված",
            ru: "Доставлено",
            en: "Delivered"
        },
        telegramInfo: {
            am: "Telegram",
            ru: "Telegram",
            en: "Telegram"
        },
        telegramId: {
            am: "Telegram ID",
            ru: "Telegram ID",
            en: "Telegram ID"
        },
        telegramLanguage: {
            am: "Լեզու",
            ru: "Язык",
            en: "Language"
        },
        verified: {
            am: "Հաստատված",
            ru: "Подтверждён",
            en: "Verified"
        },
        notVerified: {
            am: "Չհաստատված",
            ru: "Не подтверждён",
            en: "Not verified"
        },
        verify: {
            am: "Հաստատել",
            ru: "Подтвердить",
            en: "Verify"
        },
        verifySuccess: {
            am: "Հաճախորդը հաջողությամբ հաստատվեց",
            ru: "Клиент успешно подтверждён",
            en: "Customer verified successfully"
        },
        verifyError: {
            am: "Չհաջողվեց հաստատել հաճախորդին",
            ru: "Не удалось подтвердить клиента",
            en: "Failed to verify customer"
        },
        lastOrder: {
            am: "Վերջին պատվերը",
            ru: "Последний заказ",
            en: "Last order"
        },
        fullName: {
            am: "Ամբողջական անուն",
            ru: "Полное имя",
            en: "Full name"
        },
        totalRevenue: {
            am: "Ընդհանուր եկամուտ",
            ru: "Общая выручка",
            en: "Total revenue"
        },
        verifying: {
            am: "Հաստատում…",
            ru: "Подтверждение…",
            en: "Verifying…"
        },
        allCompanies: {
            am: "Բոլոր ընկերությունները",
            ru: "Все компании",
            en: "All companies"
        },
        noCompany: {
            am: "Առանց ընկերության",
            ru: "Без компании",
            en: "No company"
        },
        byCompany: {
            am: "Հաճախորդներն ըստ ընկերության",
            ru: "Клиенты по компаниям",
            en: "Clients by company"
        },
        ordersShort: {
            am: "պատվեր",
            ru: "заказов",
            en: "orders"
        },
        sortBy: {
            am: "Դասավորել",
            ru: "Сортировать",
            en: "Sort by"
        },
        sortLatestOrder: {
            am: "Վերջին պատվեր",
            ru: "Последний заказ",
            en: "Latest order"
        },
        sortOrdersCount: {
            am: "Պատվերների քանակ",
            ru: "Кол-во заказов",
            en: "Orders count"
        },
        sortTotalSpent: {
            am: "Ծախսված գումար",
            ru: "Потрачено",
            en: "Total spent"
        },
        sortName: {
            am: "Անուն",
            ru: "Имя",
            en: "Name"
        },
        firstOrder: {
            am: "Առաջին պատվերը",
            ru: "Первый заказ",
            en: "First order"
        },
        giveCoupon: {
            am: "Տալ կուպոն",
            ru: "Дать купон",
            en: "Give coupon"
        }
    },

    development: {
        cachesCleared: {
            am: "Բոլոր քեշերը հաջողությամբ մաքրվեցին:",
            ru: "Все кэши успешно очищены!",
            en: "All caches cleared successfully!"
        },
        cachesClearFailed: {
            am: "Չհաջողվեց մաքրել քեշերը",
            ru: "Не удалось очистить кэши",
            en: "Failed to clear caches"
        }
    },

    delivery: {
        title: {
            am: "Առաքման կարգավորումներ",
            ru: "Настройки доставки",
            en: "Delivery Configuration"
        },
        description: {
            am: "Կարգավորեք ձեր առաքման մեթոդները և գները",
            ru: "Настройте методы доставки и цены",
            en: "Configure your delivery methods and prices"
        },
        addMethod: {
            am: "Ավելացնել առաքման մեթոդ",
            ru: "Добавить метод доставки",
            en: "Add Delivery Method"
        },
        noMethods: {
            am: "Դեռ չկան առաքման մեթոդներ:",
            ru: "Методы доставки еще не добавлены",
            en: "No delivery methods added yet"
        },
        methodType: {
            am: "Առաքման տեսակ",
            ru: "Тип доставки",
            en: "Delivery Type"
        },
        deliveryPrice: {
            am: "Առաքման Գներ",
            ru: "Стоимость Доставки",
            en: "Delivery Pricing"
        },
        freeDeliveryFrom: {
            am: "Անվճար առաքում սկսած (֏)",
            ru: "Бесплатная доставка от (֏)",
            en: "Free Delivery From (֏)"
        },
        upperLimitKm: {
            am: "Առավելագույն հեռավորություն (կմ)",
            ru: "Максимальное расстояние (км)",
            en: "Maximum Distance (km)"
        },
        configuration: {
            am: "Կարգավորում",
            ru: "Конфигурация",
            en: "Configuration"
        },
        fixedRanges: {
            am: "Ֆիքսված՝ ըստ հեռավորության",
            ru: "Фиксированная по расстоянию",
            en: "Fixed Price by Distance"
        },
        perKm: {
            am: "Կիլոմետրի արժեք",
            ru: "Цена за километр",
            en: "Per Kilometer Rate"
        },
        fixedThenPerKm: {
            am: "Ֆիքսված + Կմ-ի գին",
            ru: "База + Цена за км",
            en: "Base Price + Per KM"
        },
        yandex: {
            am: "Yandex-ի սակագներ",
            ru: "Тарифы Yandex",
            en: "Yandex Delivery Rates"
        },
        takeaway: {
            am: "Միացնել «Վերցնել Տեղից» տարբերակը",
            ru: "Включить Самовывоз",
            en: "Enable Pickup Option"
        },
        takeawayDescription: {
            am: "Միացրեք ինքնավերցման տարբերակը հաճախորդների համար",
            ru: "Включите опцию самовывоза для клиентов",
            en: "Enable self-pickup option for customers"
        },
        selectMethod: {
            am: "Ընտրեք առաքման մեթոդ (ընտրովի)",
            ru: "Выберите метод доставки (необязательно)",
            en: "Select a delivery method (optional)"
        },
        selectAtLeastOne: {
            am: "Խնդրում ենք միացնել ինքնավերցումը կամ ընտրել առաքման մեթոդ",
            ru: "Пожалуйста, включите самовывоз или выберите метод доставки",
            en: "Please enable takeaway or select a delivery method"
        },
        typesLoadError: {
            am: "Չհաջողվեց բեռնել առաքման մեթոդների տեսակները",
            ru: "Не удалось загрузить типы методов доставки",
            en: "Failed to load delivery method types"
        },
        typesLoadErrorDesc: {
            am: "Հնարավոր չէ բեռնել առաքման մեթոդների տեսակները սերվերից: Խնդրում ենք թարմացնել էջը կամ դիմել աջակցության բաժին",
            ru: "Не удалось загрузить типы методов доставки с сервера. Пожалуйста, обновите страницу или обратитесь в службу поддержки",
            en: "Unable to load delivery method types from the server. Please refresh the page or contact support"
        },
        methodsLoadError: {
            am: "Չհաջողվեց բեռնել առաքման մեթոդները",
            ru: "Не удалось загрузить методы доставки",
            en: "Failed to load delivery methods"
        },
        methodsLoadErrorDesc: {
            am: "Հնարավոր չէ բեռնել ձեր ներկա առաքման մեթոդները սերվերից: Հնարավոր է, որ փոփոխությունները չպահպանվեն",
            ru: "Не удалось загрузить ваши текущие методы доставки с сервера. Изменения могут не сохраниться",
            en: "Unable to load your current delivery methods from the server. Changes may not save correctly"
        },
        methodsLoadWarning: {
            am: "Ուշադրություն: Հնարավոր չէ բեռնել ներկա առաքման մեթոդները: Փոփոխությունները կարող են չպահպանվել",
            ru: "Предупреждение: Не удалось загрузить текущие методы доставки. Изменения могут не сохраниться",
            en: "Warning: Could not load current delivery methods. Changes may not save correctly"
        },
        cannotSaveLoadError: {
            am: "Չի կարող պահպանվել: Հնարավոր չէ բեռնել առաքման մեթոդները սերվերից: Խնդրում ենք ստուգել ձեր կապը և փորձել կրկին",
            ru: "Не удалось сохранить: Не удалось загрузить методы доставки с сервера. Пожалуйста, проверьте подключение и попробуйте снова",
            en: "Cannot save: Unable to load delivery methods from server. Please check your connection and try again"
        },
        saveError: {
            am: "Չհաջողվեց պահպանել առաքման մեթոդները: Խնդրում ենք փորձել կրկին",
            ru: "Не удалось сохранить методы доставки. Пожалуйста, попробуйте снова",
            en: "Failed to save delivery methods. Please try again"
        },
        loadingTypes: {
            am: "Բեռնվում են առաքման մեթոդների տեսակները...",
            ru: "Загрузка типов методов доставки...",
            en: "Loading delivery method types..."
        },
        customWithYandexRate: {
            am: "Yandex-ի սակագներ",
            ru: "Тарифы Yandex",
            en: "Yandex Delivery Rates"
        },
        rangeKm: {
            am: "Տարածք (կմ)",
            ru: "Диапазон (км)",
            en: "Range (km)"
        },
        price: {
            am: "Գին (֏)",
            ru: "Цена (֏)",
            en: "Price (֏)"
        },
        fixedPrice: {
            am: "Ֆիքսված գին (֏)",
            ru: "Фиксированная цена (֏)",
            en: "Fixed Price (֏)"
        },
        pricePerKm: {
            am: "Գինը մեկ կմ-ի համար",
            ru: "Цена за км",
            en: "Price per km"
        },
        deliveryPricePerKm: {
            am: "Կիլոմետրի արժեք",
            ru: "Цена за километр",
            en: "Per Kilometer Rate"
        },
        thresholdKm: {
            am: "Սկզբնական հեռավորություն (կմ)",
            ru: "Пороговое расстояние (км)",
            en: "Threshold Distance (km)"
        },
        addRange: {
            am: "Ավելացնել",
            ru: "Добавить",
            en: "Add Range"
        },
        remove: {
            am: "Հեռացնել",
            ru: "Удалить",
            en: "Remove"
        },
        save: {
            am: "Պահպանել",
            ru: "Сохранить",
            en: "Save"
        },
        cancel: {
            am: "Չեղարկել",
            ru: "Отменить",
            en: "Cancel"
        },
        saving: {
            am: "Պահպանվում է...",
            ru: "Сохранение...",
            en: "Saving..."
        },
        saved: {
            am: "Կարգավորումները հաջողությամբ պահպանվեցին",
            ru: "Настройки успешно сохранены",
            en: "Configuration saved successfully"
        },
        error: {
            am: "Չհաջողվեց պահպանել կարգավորումները",
            ru: "Не удалось сохранить настройки",
            en: "Failed to save configuration"
        },
        validation: {
            methodTypeRequired: {
                am: "Առաքման տեսակը պարտադիր է",
                ru: "Тип доставки обязателен",
                en: "Delivery type is required"
            },
            atLeastOneRange: {
                am: "Առնվազն մեկ միջակայք պարտադիր է",
                ru: "Требуется хотя бы один диапазон",
                en: "At least one range is required"
            },
            pricePerKmRequired: {
                am: "Գինը մեկ կմ-ի համար պարտադիր է",
                ru: "Цена за километр обязательна",
                en: "Price per km is required"
            },
            fixedPriceRequired: {
                am: "Ֆիքսված գինը պարտադիր է",
                ru: "Фиксированная цена обязательна",
                en: "Fixed price is required"
            },
            thresholdRequired: {
                am: "Սկզբնական հեռավորությունը պարտադիր է",
                ru: "Пороговое расстояние обязательно",
                en: "Threshold distance is required"
            },
            rangeRequired: {
                am: "Առնվազն մեկ միջակայք պարտադիր է",
                ru: "Требуется хотя бы один диапазон",
                en: "At least one range is required"
            },
            priceRequired: {
                am: "Գումարը պարտադիր է",
                ru: "Сумма обязательна",
                en: "Amount is required"
            },
            invalidNumber: {
                am: "Մուտքագրեք վավեր թիվ",
                ru: "Введите действительное число",
                en: "Enter a valid number"
            },
            rangeMustBePositive: {
                am: "Պետք է լինի > 0",
                ru: "Должно быть > 0",
                en: "Must be > 0"
            },
            distanceGreaterThan: {
                am: "Պետք է լինի > {{prevMax}}կմ",
                ru: "Должно быть > {{prevMax}}км",
                en: "Must be > {{prevMax}}km"
            },
            priceMustBePositive: {
                am: "Պետք է լինի ոչ բացասական",
                ru: "Должно быть неотрицательным",
                en: "Must be non-negative"
            },
            distanceRequired: {
                am: "Հեռավորությունը պարտադիր է",
                ru: "Расстояние обязательно",
                en: "Distance is required"
            },
            distancePositive: {
                am: "Պետք է լինի > 0",
                ru: "Должно быть > 0",
                en: "Must be > 0"
            },
            amountRequired: {
                am: "Գումարը պարտադիր է",
                ru: "Сумма обязательна",
                en: "Amount is required"
            },
            amountNonNegative: {
                am: "Պետք է լինի ոչ բացասական",
                ru: "Должно быть неотрицательным",
                en: "Must be non-negative"
            },
            perKmRequired: {
                am: "Գինը մեկ կմ-ի համար պարտադիր է",
                ru: "Цена за км обязательна",
                en: "Amount per km is required"
            },
            maxDistanceNonNegative: {
                am: "Պետք է լինի ոչ բացասական թիվ",
                ru: "Должно быть неотрицательным числом",
                en: "Must be a non-negative number"
            }
        },
        deliveryPriceType: {
            am: "Գնագոյացման Տեսակ",
            ru: "Модель Ценообразования",
            en: "Pricing Model"
        },
        deliveryPriceFixedRanges: {
            am: "Ֆիքսված՝ ըստ հեռավորության",
            ru: "Фиксированная по расстоянию",
            en: "Fixed Price by Distance"
        },
        deliveryPriceFixedRangePerKm: {
            am: "Ֆիքսված + Կմ-ի գին",
            ru: "База + Цена за км",
            en: "Base Price + Per KM"
        },
        deliveryPriceYandex: {
            am: "Yandex-ի սակագներ",
            ru: "Тарифы Yandex",
            en: "Yandex Delivery Rates"
        },
        fixedRangesHelp: {
            am: "Սահմանեք հեռավորության միջակայքերը և դրանց առաքման գները։ Օրինակ՝ «5կմ: 500» նշանակում է մինչև 5կմ առաքումը արժե 500։",
            ru: "Определите диапазоны расстояний и цены. Например, «5км: 500» означает, что доставка до 5км стоит 500.",
            en: "Define distance tiers and their corresponding delivery prices. For example, '5km: 500' means delivery up to 5km costs 500."
        },
        fixedRangePerKmHelp: {
            am: "Սահմանեք ֆիքսված բազային գին, հեռավորության շեմ և այդ շեմից հետո կիրառվող կիլոմետրի արժեքը։",
            ru: "Установите фиксированную базовую цену, порог расстояния и тариф за километр, действующий после этого порога.",
            en: "Set a fixed base price, a distance threshold, and the per-kilometer rate that applies after that distance."
        },
        distanceLabel: {
            am: "Հեռավորություն (կմ)",
            ru: "Расстояние (км)",
            en: "Distance (km)"
        },
        distancePlaceholder: {
            am: "օր.՝ 5",
            ru: "напр. 5",
            en: "e.g. 5"
        },
        priceLabel: {
            am: "Առաքման Գին",
            ru: "Цена Доставки",
            en: "Delivery Price"
        },
        amountPlaceholder: {
            am: "Գումար",
            ru: "Сумма",
            en: "Amount"
        },
        basePrice: {
            am: "Ֆիքսված Բազային Գին",
            ru: "Фиксированная Базовая Цена",
            en: "Fixed Base Price"
        },
        fixedPricePlaceholder: {
            am: "Ֆիքսված Գին",
            ru: "Фиксированная цена",
            en: "Fixed Price"
        },
        distanceThreshold: {
            am: "Հեռավորության Շեմ (կմ)",
            ru: "Порог Расстояния (км)",
            en: "Distance Threshold (km)"
        },
        distanceThresholdPlaceholder: {
            am: "X կմ-ից հետո",
            ru: "После X км",
            en: "After X km"
        },
        pricePerKmLabel: {
            am: "Գինը 1 կմ-ի համար",
            ru: "Цена за км",
            en: "Price Per km"
        },
        perKmSuffix: {
            am: "1 կմ-ի համար",
            ru: "за км",
            en: "per km"
        },
        deliveryFreeThreshold: {
            am: "Անվճար Առաքում՝ Սկսած",
            ru: "Бесплатно при заказе от",
            en: "Free Delivery Over"
        },
        deliveryMaxDistance: {
            am: "Առաքման Առավելագույն Շառավիղ",
            ru: "Макс. Радиус Доставки",
            en: "Max Delivery Radius"
        },
        orderAmountThresholdPlaceholder: {
            am: "Պատվերի նվազագույն գումար",
            ru: "Минимальная сумма заказа",
            en: "Order amount threshold"
        },
        maxDistancePlaceholder: {
            am: "Առավելագույն հեռավորություն (կմ)",
            ru: "Максимальное расстояние (км)",
            en: "Maximum distance (km)"
        }
    },

    // Import feature translations (top-level for getTranslation('import.*'))
    import: {
        title: {
            am: "Ներմուծել Մենյու",
            ru: "Импорт Меню",
            en: "Import Menu"
        },
        import: {
            am: "Ներմուծել",
            ru: "Импорт",
            en: "Import"
        },
        downloadTemplate: {
            am: "Ներբեռնել Ձևանմուշ",
            ru: "Скачать Шаблон",
            en: "Download Template"
        },
        selectDataFile: {
            am: "Ընտրել Տվյալների Ֆայլ",
            ru: "Выбрать Файл Данных",
            en: "Select Data File"
        },
        dataFileDescription: {
            am: "Վերբեռնեք CSV կամ Excel ֆայլ, որը պարունակում է ուտեստների տվյալներ",
            ru: "Загрузите CSV или Excel файл с данными блюд",
            en: "Upload a CSV or Excel file containing dish data"
        },
        dragDropDataFile: {
            am: "Քաշեք և գցեք ձեր տվյալների ֆայլը այստեղ",
            ru: "Перетащите файл данных сюда",
            en: "Drag and drop your data file here"
        },
        selectImageZip: {
            am: "Ընտրել Պատկերների ZIP (Ընտրովի)",
            ru: "Выбрать ZIP с Изображениями (Опционально)",
            en: "Select Image ZIP (Optional)"
        },
        imageZipDescription: {
            am: "Վերբեռնեք ZIP ֆայլ, որը պարունակում է ուտեստների պատկերներ: Պատկերները պետք է համապատասխանեն ձեր տվյալների ֆայլի ֆայլերի անուններին:",
            ru: "Загрузите ZIP файл с изображениями блюд. Имена файлов должны соответствовать именам в файле данных.",
            en: "Upload a ZIP file containing dish images. Images should match the filenames in your data file."
        },
        dragDropImageZip: {
            am: "Քաշեք և գցեք ձեր պատկերների ZIP ֆայլը այստեղ",
            ru: "Перетащите ZIP файл с изображениями сюда",
            en: "Drag and drop your image ZIP file here"
        },
        next: {
            am: "Հաջորդ",
            ru: "Далее",
            en: "Next"
        },
        parsing: {
            am: "Վերլուծվում է...",
            ru: "Парсинг...",
            en: "Parsing..."
        },
        fileParsed: {
            am: "Ֆայլը վերլուծվեց",
            ru: "Файл распарсен",
            en: "File parsed"
        },
        status: {
            am: "Կարգավիճակ",
            ru: "Статус",
            en: "Status"
        },
        name: {
            am: "Անուն",
            ru: "Название",
            en: "Name"
        },
        type: {
            am: "Տեսակ",
            ru: "Тип",
            en: "Type"
        },
        price: {
            am: "Գին",
            ru: "Цена",
            en: "Price"
        },
        errorDetails: {
            am: "Սխալների մանրամասներ",
            ru: "Детали ошибок",
            en: "Error Details"
        },
        warnings: {
            am: "Նախազգուշացումներ",
            ru: "Предупреждения",
            en: "Warnings"
        },
        total: {
            am: "Ընդամենը",
            ru: "Всего",
            en: "Total"
        },
        valid: {
            am: "Վավեր",
            ru: "Валидные",
            en: "Valid"
        },
        invalid: {
            am: "Անվավեր",
            ru: "Невалидные",
            en: "Invalid"
        },
        selected: {
            am: "Ընտրված",
            ru: "Выбрано",
            en: "Selected"
        },
        searchPlaceholder: {
            am: "Որոնել ուտեստներ...",
            ru: "Поиск блюд...",
            en: "Search dishes..."
        },
        all: {
            am: "Բոլորը",
            ru: "Все",
            en: "All"
        },
        acceptedTypesLabel: {
            am: "Ընդունելի ֆորմատներ: {types} (մաքս {size}ՄԲ)",
            ru: "Допустимые форматы: {types} (макс {size}МБ)",
            en: "Accepted: {types} (max {size}MB)"
        },
        acceptedTypesLabelZip: {
            am: "Ընդունելի ZIP: {types} (մաքս {size}ՄԲ)",
            ru: "Допустимые ZIP: {types} (макс {size}МБ)",
            en: "Accepted: {types} (max {size}MB)"
        },
        selectFile: {
            am: "Ընտրել Ֆայլ",
            ru: "Выбрать Файл",
            en: "Select File"
        },
        confirmImport: {
            am: "Հաստատել Ներմուծումը",
            ru: "Подтвердить Импорт",
            en: "Confirm Import"
        },
        importingDishes: {
            am: "Ներմուծվում են ուտեստները...",
            ru: "Импортируются блюда...",
            en: "Importing dishes..."
        },
        pleaseWait: {
            am: "Խնդրում ենք սպասել, մինչ մենք ներմուծում ենք ձեր ուտեստները",
            ru: "Пожалуйста, подождите, пока мы импортируем ваши блюда",
            en: "Please wait while we import your dishes"
        },
        importComplete: {
            am: "Ներմուծումը Ավարտված է",
            ru: "Импорт Завершен",
            en: "Import Complete"
        },
        exportErrorReport: {
            am: "Արտահանել Սխալների Հաշվետվություն",
            ru: "Экспорт Отчета об Ошибках",
            en: "Export Error Report"
        },
        cancel: {
            am: "Չեղարկել",
            ru: "Отменить",
            en: "Cancel"
        },
        importCancelled: {
            am: "Ներմուծումը չեղարկվեց",
            ru: "Импорт отменен",
            en: "Import cancelled"
        },
        success: {
            am: "Հաջող",
            ru: "Успешно",
            en: "Success"
        },
        failed: {
            am: "Ձախողված",
            ru: "Неудачно",
            en: "Failed"
        },
        templateDownloaded: {
            am: "Ձևանմուշը հաջողությամբ ներբեռնվեց",
            ru: "Шаблон успешно загружен",
            en: "Template downloaded successfully"
        },
        importSuccess: {
            am: "Մենյուն հաջողությամբ ներմուծվեց",
            ru: "Меню успешно импортировано",
            en: "Menu imported successfully"
        },
        importPartialSuccess: {
            am: "Ներմուծվեց {count} ուտեստ, {failed} ձախողվեց",
            ru: "Импортировано {count} блюд, {failed} не удалось",
            en: "Imported {count} dish{plural}, {failed} failed"
        },
        importAllFailed: {
            am: "Բոլոր {count} ուտեստները ձախողվեցին",
            ru: "Все {count} блюда не удалось импортировать",
            en: "All {count} dish{plural} failed to import"
        },
        selectAll: {
            am: "Ընտրել Բոլորը",
            ru: "Выбрать Все",
            en: "Select All"
        },
        deselectAll: {
            am: "Ապաընտրել Բոլորը",
            ru: "Снять Выделение",
            en: "Deselect All"
        },
        unknown: {
            am: "Անհայտ",
            ru: "Неизвестно",
            en: "Unknown"
        },
        warning: {
            am: "Նախազգուշացում",
            ru: "Предупреждение",
            en: "Warning"
        },
        errors: {
            am: "Սխալներ",
            ru: "Ошибки",
            en: "Errors"
        },
        errorRow: {
            am: "Տող",
            ru: "Строка",
            en: "Row"
        },
        moreErrors: {
            am: "... և {count} այլ սխալ",
            ru: "... и еще {count} ошибок",
            en: "... and {count} more errors"
        },
        // Error and warning messages
        importErrorMessages: {
            nameHyRequired: {
                am: "Անունը (Հայերեն) պարտադիր է",
                ru: "Название (Армянский) обязательно",
                en: "Name (Armenian) is required"
            },
            typeRequired: {
                am: "Տեսակը պարտադիր է",
                ru: "Тип обязателен",
                en: "Type is required"
            },
            invalidType: {
                am: "Անվավեր տեսակ",
                ru: "Неверный тип",
                en: "Invalid type"
            },
            expirationDateRequired: {
                am: "Ժամկետը պարտադիր է և պետք է լինի թիվ",
                ru: "Срок годности обязателен и должен быть числом",
                en: "Expiration Date is required and must be a number"
            },
            ingredientHyRequired: {
                am: "Բաղադրիչները (Հայերեն) պարտադիր են",
                ru: "Ингредиенты (Армянский) обязательны",
                en: "Ingredients (Armenian) is required"
            },
            dishTagRequired: {
                am: "Կատեգորիան պարտադիր է",
                ru: "Категория обязательна",
                en: "Dish Category is required"
            },
            dishTagNotFound: {
                am: "Կատեգորիան չի գտնվել",
                ru: "Категория не найдена",
                en: "Dish Category not found"
            },
            cuisineRequired: {
                am: "Խոհանոցը պարտադիր է",
                ru: "Кухня обязательна",
                en: "Cuisine is required"
            },
            cuisineNotFound: {
                am: "Խոհանոցը չի գտնվել",
                ru: "Кухня не найдена",
                en: "Cuisine not found"
            },
            spiceLevelRequired: {
                am: "Կծվության մակարդակը պարտադիր է (1-4)",
                ru: "Уровень остроты обязателен (1-4)",
                en: "Spice Level is required (1-4)"
            },
            invalidSpiceLevel: {
                am: "Կծվության մակարդակը պետք է լինի 1-4 միջակայքում",
                ru: "Уровень остроты должен быть от 1 до 4",
                en: "Spice Level must be between 1 and 4"
            },
            invalidPrice: {
                am: "Գինը պետք է լինի վավեր դրական թիվ",
                ru: "Цена должна быть действительным положительным числом",
                en: "Price must be a valid positive number"
            },
            loadContextFailed: {
                am: "Վավերացման տվյալները բեռնելը ձախողվեց",
                ru: "Не удалось загрузить данные валидации",
                en: "Failed to load validation data"
            },
            parseFailed: {
                am: "Ֆայլի վերլուծումը ձախողվեց",
                ru: "Не удалось распарсить файл",
                en: "Failed to parse file"
            },
            noRowsSelected: {
                am: "Խնդրում ենք ընտրել առնվազն մեկ տող ներմուծելու համար",
                ru: "Пожалуйста, выберите хотя бы одну строку для импорта",
                en: "Please select at least one row to import"
            },
            noValidRows: {
                am: "Վավեր տողեր չեն ընտրվել: Խնդրում ենք ընտրել միայն վավեր տողեր:",
                ru: "Не выбрано валидных строк. Пожалуйста, выберите только валидные строки.",
                en: "No valid rows selected. Please select valid rows only."
            },
            importFailed: {
                am: "Ներմուծումը ձախողվեց",
                ru: "Импорт не удался",
                en: "Import failed"
            },
            templateDownloadFailed: {
                am: "Ձևանմուշի ներբեռնումը ձախողվեց",
                ru: "Не удалось загрузить шаблон",
                en: "Failed to download template"
            },
            noDataFile: {
                am: "Խնդրում ենք նախ ընտրել տվյալների ֆայլ",
                ru: "Пожалуйста, сначала выберите файл данных",
                en: "Please select a data file first"
            }
        },
        importWarningMessages: {
            invalidOrderBefore: {
                am: "Պատվերի նախօրոք պետք է լինի վավեր թիվ: Օգտագործվում է լռելյայն արժեքը: 1",
                ru: "Предзаказ должен быть действительным числом. Используется значение по умолчанию: 1",
                en: "Order Before must be a valid number. Using default value: 1"
            },
            invalidMinimumOrderCount: {
                am: "Նվազագույն պատվերի քանակը պետք է լինի առնվազն 1: Օգտագործվում է լռելյայն արժեքը: 1",
                ru: "Минимальное количество заказа должно быть не менее 1. Используется значение по умолчанию: 1",
                en: "Minimum Order Count must be at least 1. Using default value: 1"
            },
            noImage: {
                am: "Պատկեր չի տրամադրվել: Ուտեստը կստեղծվի առանց պատկերի:",
                ru: "Изображение не предоставлено. Блюдо будет создано без изображения.",
                en: "No image provided. Dish will be created without an image."
            },
            duplicateDish: {
                am: "Այս անունով ուտեստ արդեն գոյություն ունի: Այս տողը կբաց թողնվի:",
                ru: "Блюдо с таким названием уже существует. Эта строка будет пропущена.",
                en: "Dish with this name already exists. This row will be skipped."
            }
        }
    },
    configurations: {
        pageTitle: {
            am: "Կարգավորումներ",
            ru: "Настройки",
            en: "Configurations"
        },
        additionGroups: {
            am: "Հավելումների խմբեր",
            ru: "Группы дополнений",
            en: "Addition Groups"
        },
        additions: {
            am: "Հավելումներ",
            ru: "Дополнения",
            en: "Additions"
        },
        addGroup: {
            am: "+ Ավելացնել խումբ",
            ru: "+ Добавить группу",
            en: "+ Add Group"
        },
        newGroup: {
            am: "Նոր խումբ",
            ru: "Новая группа",
            en: "New Group"
        },
        editGroup: {
            am: "Խմբագրել խումբ",
            ru: "Редактировать группу",
            en: "Edit Group"
        },
        newAddition: {
            am: "Նոր հավելում",
            ru: "Новое дополнение",
            en: "New Addition"
        },
        editAddition: {
            am: "Խմբագրել հավելում",
            ru: "Редактировать дополнение",
            en: "Edit Addition"
        },
        nameArmenian: {
            am: "Անուն (Հայերեն)",
            ru: "Название (Армянский)",
            en: "Name (Armenian)"
        },
        nameRussian: {
            am: "Անուն (Ռուսերեն)",
            ru: "Название (Русский)",
            en: "Name (Russian)"
        },
        nameEnglish: {
            am: "Անուն (Անգլերեն)",
            ru: "Название (Английский)",
            en: "Name (English)"
        },
        price: {
            am: "Գին",
            ru: "Цена",
            en: "Price"
        },
        group: {
            am: "Խումբ",
            ru: "Группа",
            en: "Group"
        },
        noGroup: {
            am: "Խումբ չկա",
            ru: "Нет группы",
            en: "No Group"
        },
        allowMultiple: {
            am: "Թույլատրել բազմակի ընտրություն",
            ru: "Разрешить множественный выбор",
            en: "Allow Multiple Selection"
        },
        required: {
            am: "Պարտադիր",
            ru: "Обязательно",
            en: "Required"
        },
        optional: {
            am: "Ընտրովի",
            ru: "Необязательно",
            en: "Optional"
        },
        multiple: {
            am: "Բազմակի",
            ru: "Множественный",
            en: "Multiple"
        },
        single: {
            am: "Մեկ",
            ru: "Один",
            en: "Single"
        },
        translate: {
            am: "Թարգմանել",
            ru: "Перевести",
            en: "Translate"
        },
        myGroup: {
            am: "Իմ խումբ",
            ru: "Моя группа",
            en: "My Group"
        },
        global: {
            am: "Գլոբալ",
            ru: "Глобальный",
            en: "Global"
        },
        ungrouped: {
            am: "Չխմբավորված",
            ru: "Без группы",
            en: "Ungrouped"
        },
        noGroups: {
            am: "Խմբեր չկան",
            ru: "Нет групп",
            en: "No groups"
        },
        noAdditionsInGroup: {
            am: "Հավելումներ չկան",
            ru: "Нет дополнений",
            en: "No additions"
        },
        allNamesRequired: {
            am: "Բոլոր անունները պարտադիր են",
            ru: "Все названия обязательны",
            en: "All names are required"
        },
        allAdditionFieldsRequired: {
            am: "Բոլոր դաշտերը պարտադիր են",
            ru: "Все поля обязательны",
            en: "All fields are required"
        },
        groupCreated: {
            am: "Խումբը հաջողությամբ ստեղծվեց",
            ru: "Группа успешно создана",
            en: "Group created successfully"
        },
        groupUpdated: {
            am: "Խումբը հաջողությամբ թարմացվեց",
            ru: "Группа успешно обновлена",
            en: "Group updated successfully"
        },
        groupDeleted: {
            am: "Խումբը հաջողությամբ ջնջվեց",
            ru: "Группа успешно удалена",
            en: "Group deleted successfully"
        },
        groupSaveError: {
            am: "Խմբի պահպանումը ձախողվեց",
            ru: "Не удалось сохранить группу",
            en: "Failed to save group"
        },
        groupDeleteError: {
            am: "Խմբի ջնջումը ձախողվեց",
            ru: "Не удалось удалить группу",
            en: "Failed to delete group"
        },
        groupInUse: {
            am: "Խումբը չի կարող ջնջվել, քանի որ այն օգտագործվում է հավելումներում: Խնդրում ենք նախ հեռացնել կամ վերագրել հավելումները:",
            ru: "Группу нельзя удалить, так как она используется в дополнениях. Пожалуйста, сначала удалите или переназначьте дополнения.",
            en: "Cannot delete group because it has associated additions. Please remove or reassign additions first."
        },
        cannotEditGlobal: {
            am: "Գլոբալ խմբերը չեն կարող խմբագրվել",
            ru: "Глобальные группы нельзя редактировать",
            en: "Cannot edit global groups"
        },
        additionCreated: {
            am: "Հավելումը հաջողությամբ ստեղծվեց",
            ru: "Дополнение успешно создано",
            en: "Addition created successfully"
        },
        additionUpdated: {
            am: "Հավելումը հաջողությամբ թարմացվեց",
            ru: "Дополнение успешно обновлено",
            en: "Addition updated successfully"
        },
        additionDeleted: {
            am: "Հավելումը հաջողությամբ ջնջվեց",
            ru: "Дополнение успешно удалено",
            en: "Addition deleted successfully"
        },
        additionSaveError: {
            am: "Հավելումի պահպանումը ձախողվեց",
            ru: "Не удалось сохранить дополнение",
            en: "Failed to save addition"
        },
        additionDeleteError: {
            am: "Հավելումի ջնջումը ձախողվեց",
            ru: "Не удалось удалить дополнение",
            en: "Failed to delete addition"
        },
        fetchError: {
            am: "Կարգավորումների բեռնումը ձախողվեց",
            ru: "Не удалось загрузить настройки",
            en: "Failed to load configurations"
        },
        confirmDeleteGroup: {
            am: "Դուք համոզված եք, որ ցանկանում եք ջնջել այս խումբը?",
            ru: "Вы уверены, что хотите удалить эту группу?",
            en: "Are you sure you want to delete this group?"
        },
        confirmDeleteAddition: {
            am: "Դուք համոզված եք, որ ցանկանում եք ջնջել այս հավելումը?",
            ru: "Вы уверены, что хотите удалить это дополнение?",
            en: "Are you sure you want to delete this addition?"
        }
    },
    integrations: {
        pageTitle: {
            am: "Ինտեգրումներ",
            ru: "Интеграции",
            en: "Integrations"
        },
        pageHint: {
            am: "Կապեք NopCommerce ապրանքի ID-ն ձեր ուտեստի հետ, որպեսզի արտաքին պատվերները ճիշտ ցուցադրվեն։",
            ru: "Свяжите ID товара NopCommerce с блюдом, чтобы внешние заказы отображались корректно.",
            en: "Map each NopCommerce product id to a ByChef dish so persisted Nop orders line up with your menu."
        },
        noConfigs: {
            am: "Ինտեգրման կարգավորում չկա։ Ադմինը կարող է ավելացնել այն Ratatouille-ում։",
            ru: "Нет настроек интеграции. Админ может добавить их в Ratatouille.",
            en: "No integration configs yet. An admin can add one in Ratatouille."
        },
        config: {
            am: "Կարգավորում",
            ru: "Конфигурация",
            en: "Config"
        },
        mappingTitle: {
            am: "Ապրանք → ուտեստ",
            ru: "Товар → блюдо",
            en: "Product → dish"
        },
        nopProductId: {
            am: "Nop ապրանքի ID",
            ru: "ID товара Nop",
            en: "Nop product id"
        },
        bychefDish: {
            am: "ByChef ուտեստ",
            ru: "Блюдо ByChef",
            en: "ByChef dish"
        },
        selectDish: {
            am: "Ընտրեք ուտեստ",
            ru: "Выберите блюдо",
            en: "Select a dish"
        },
        saveMapping: {
            am: "Պահպանել",
            ru: "Сохранить",
            en: "Save mapping"
        },
        noMappings: {
            am: "Համապատասխանություններ չկան",
            ru: "Соответствий пока нет",
            en: "No mappings yet"
        },
        mappingRequired: {
            am: "Ապրանքի ID-ն և ուտեստը պարտադիր են",
            ru: "Нужны ID товара и блюдо",
            en: "Product id and dish are required"
        },
        mappingSaved: {
            am: "Համապատասխանությունը պահպանվեց",
            ru: "Соответствие сохранено",
            en: "Mapping saved"
        },
        mappingSaveError: {
            am: "Չհաջողվեց պահպանել",
            ru: "Не удалось сохранить",
            en: "Failed to save mapping"
        },
        mappingDeleted: {
            am: "Համապատասխանությունը ջնջվեց",
            ru: "Соответствие удалено",
            en: "Mapping deleted"
        },
        mappingDeleteError: {
            am: "Չհաջողվեց ջնջել",
            ru: "Не удалось удалить",
            en: "Failed to delete mapping"
        },
        loadMappingsError: {
            am: "Չհաջողվեց բեռնել համապատասխանությունները",
            ru: "Не удалось загрузить соответствия",
            en: "Failed to load mappings"
        },
        confirmDeleteMapping: {
            am: "Ջնջե՞լ այս համապատասխանությունը:",
            ru: "Удалить это соответствие?",
            en: "Delete this product mapping?"
        }
    }
};
